import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators, NgForm} from '@angular/forms';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { fuseAnimations } from '@fuse/animations';
import { ActivatedRoute } from '@angular/router';
import *  as $ from 'jquery';
import {FormControl} from '@angular/forms';
///IDIOMAS
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_resultados } from 'app/idiomas/i18n/resultados/resultados.lang';
import { lang_confirmaEncu } from 'app/idiomas/i18n/confirmarEncu/confirmaEncu.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Envion35Service } from 'app/main/wizard-n35encuestador/services/envion35.service';
//SERVICE
import { ODSService } from "../services/ods.service";
import * as backInter from 'app/auth/auth-data.model';
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import Swal from 'sweetalert2';
import * as catSecciones from './cat-secciones';
import { PdfMakeWrapper, Txt, Ul, Item, Columns } from 'pdfmake-wrapper';
import { ProgramacionService } from 'app/main/wizard-cgo/services/programacion.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Inject} from '@angular/core';
import { IdiomasService } from 'app/main/wizard-cgo/services/idiomas.service';
import { DATOS_API } from 'app/auth/auth.datos';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';

import { DescargaEncuestaComponent } from "./descarga-encuesta/descarga-encuesta.component";
import { InfoRTComponent } from "./info-rt/info-rt.component";
import { ConfigResultComponent } from "./config-result/config-result.component";
import { InfraStructComponent } from "./infra-struct/infra-struct.component";
import { ResultEmprisingComponent } from "./result-emprising/result-emprising.component";
import { EncuestaService } from 'app/main/wizard-cgo/services/encuesta.service';
export let nom35: any[] = [
  {
    id: "1",
    nombre: "Menos de 50",
  },
  {
    id: "2",
    nombre: "Más de 50",
  }
];
/**
* @title Stepper with editable steps
*/
@Component({
  selector: 'detail-component',
  templateUrl: 'detail.component.html',
  styleUrls: ['detail.component.scss'],
  animations : fuseAnimations
})


export class DetailComponent  implements OnInit {

  sections = [
    'NPS',
    'Reactivos',
    'Control',
    'Demograficos',
    'Adicionales',
    'Forall'
  ];



  isCA : boolean = false;
  instituto: number = 0;
  flagPasos : boolean = false;
  flagNps : boolean = true;
  flagReactivos : boolean = true;
  flagControl : boolean = true;
  flagDemograficos : boolean = true;
  flagAdicionales : boolean = true;
  flagForall : boolean = true;
  idEmpresa : string;
  enterpriseData : any;
  nombreEmpresa : string;
  sectorName : string;
  subsectorName : string;
  rankingName : string;
  country_application : string;
  tipoName : string;
  productosContratados : any;
  productosContratadosInter : backInter.infoProductos;
  productosDocumentadorNormaV1 : any=[];
  productosDocumentadorNormaV3 : any=[];
  productosContratadosInterTmp : backInter.infoProductos;
  productosContratadosInterPulse : backInter.infoProductos;
  years : any;
  estilos : any;
  plantillas: any;
  products : any;
  temporal:boolean = false;
  listaProductos: any[] = [];
  listaAction: any[] = [];
  listaLeaderGo: any[] = [];
  listaAudit_aux: any[] = [];
  listaProdsCertificar: any[] = [];
  listaProdsGoflow: any[] = [];
  listaProdsNorma35: any[] = [];
  listaProdsExpress: any[] = [];
  listaProdsMedir: any[] = [];
  listaProdsPulse: any[] = [];
  listaProdsFocus: any[] = [];
  listaProdsLeaderGo: any[] = [];
  listaProdsActionGo: any[] = [];
  listaProdsCerAmco: any[] = [];
  listaProdsCerEmprising: any[] = [];
  listaProductosCultureAuditV2: any[] = [];
  listaProductosCultureAuditICCA: any[] = [];
  listaProductosCultureBrief: any[] = [];
  mostrarProdsCerAmco: boolean=false;
  surveyToken: string;
  selectSector: number;
  selectPlantilla: any;
  selectPlantillaEmail: string;
  selectYear: number;
  selectEstilo: number;
  selectEstilo_Results: number;
  tipoProducto: number;
  anioranking:boolean=false;
  aplicaRanking:any;
  idiomaActual:string;
  anioRankingCert3: number;
  tipoRankingCert3: string;
  rankEnabledCert3: any;
  rangoRankingCert3: any;
  rankings: any[]=[
  {idSelect: 1, select: "Sí"},
  {idSelect: 2, select: "No"}
];
  rankingItem: any;
  oportunityId: string;
  oportunityName: string;
  typeOfResultsId: string;
  proyectManager: string;
  proyectManagerEmail: string;
  charChinos = '\u2E80-\u2FD5\u3400-\u4DBF\u4E00-\u9FCC';
  charTurcos = '\u011F\u011E\u0131\u0130\u00F6\u00D6\u00FC\u00DC\u015F\u015E\u00E7\u00C7';
  charIdiomas = this.charChinos + this.charTurcos;
  regexEmail = new RegExp("^[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?\.)+[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?$");

  plantillas_email:any;
  plantillas_lan:any;
  linkLabel:boolean=false;
  productoNorma_tmp:any;
  statusProductoNorma35:boolean=false;

  tableauVersion: string;
  aniosPulsecheck: any[]=[];
  projectManager: any[]=[];
  aniosFocusAgregados: any[]=[];
  aniosPulsecheckSelect: any[]=[];
  seccionesMedirMejorado: any[]=[];
  codigoDeProyecto:number;

  correosFaltantes: any[] = [];
  disableSelect = new FormControl(false);
  selectCertificarAsociado:any="";
  selectCertificarActionGo:any="";
  validarNivelUser:any;
  resultadosAnosAsig:any[]=[
    {anio: "2020"},
    {anio: "2021"},
    {anio: "2022"},
    {anio: "2023"},
    {anio: "2024"},
    {anio: "2025"},
    {anio: "2026"},
    {anio: "2027"},
    {anio: "2028"},
    {anio: "2029"},
    {anio: "2030"},
  ];

  urlAssetsEmail= DATOS_API.urlAssets;
  // IDS de productos clones de certificar 3, pero que no son certificar 3
  idsProductosCert3Falsos = [
    {id:41, activo: false}, // medir 3.0
    {id:42, activo: false}, // pulse check 3.0
    {id:43, activo: false}, // pulse check 3.0
    {id:53, activo: false}, // LeaderGo 3.0
    {id:54, activo: false}, // ActionGO  3.0
    {id:56, activo: false}, // ActionGO  3.0
    {id:57, activo: false}, // ActionGO  3.0
    {id:58, activo: false}, // ActionGO  3.0
    {id:60, activo: false}, // ActionGO  3.0
    {id:70, activo: false}, // Go flow  3.0
    // Certificar Plata  3.0
  ];
  btnPortalConteos:boolean;
  mostrarMenuCertificar=false;
  idsProductosCertificar = [1,20,27,40,75];
  idsProductosGralActionGo = [1,20,27,40,41];
  idsProductos3_0 = [40,41,42,43,56,57,58,69,75];
  idsIntitutos = [1,2];
  linksCultureAuditCGOX: any[] = [];
  clickButton:boolean=false;
  seleccion:any[]=[
    {idSelect: 1, select: "Sí"},
    {idSelect: 2, select: "No"}
  ]
  btnDeletProduct:boolean=false;
  verListCultureAuditV2:boolean=false;
  verListCultureBrief:boolean=false;
  idiomasRTSelect:any;
  typeOfResults:any;
  nameUser="";
  emailUser="";
  passUser="";
  totalColab="";
  correctEmailUser=false;
  correctPassUser=false;
  regalasPassRegis:any[]=[
    {
      'regla': 'longitud',
       'estatus': false,
  },
    {
      'regla': 'letraMin',
       'estatus': false,
  },
    {
      'regla': 'letraMayu',
       'estatus': false,
  },
    {
      'regla': 'numeroPass',
       'estatus': false,
  },
    {
      'regla': 'caracterPass',
       'estatus': false,
  },
];
  longitudPassRegis:boolean=false;
  letraMinPassRegis:boolean=false;
  letraMayuPassRegis:boolean=false;
  numePassRegis:boolean=false;
  caracterPassRegis:boolean=false;
  arregloReglasCumplidasRegis:any[]=[];
  idsProductosSendEmailRT = [40,41,42,43,63,56,57,58];
  idsInstitutosSendEmailRT = [1,2];
  constructor(private activatedRoute : ActivatedRoute,
    private translateSrv: TranslateService,
    private _formBuilder: FormBuilder,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private odsService: ODSService,
    private translate: TranslateService,
    private router: Router,
    public snackBar: MatSnackBar,
    private programacionService: ProgramacionService,
    public dialog: MatDialog,
    private wizardService: WizardService,
    private encuestaService: EncuestaService,

  ) {
    this.activatedRoute.params.subscribe(params => {
      this.idEmpresa = params['id'];
      this.getStatusTemplate();
      this.getEnterpriseDetail(this.idEmpresa);
      this.getYears();
      this.getEstilos();
      this.getRankingArray();
      this.getProductsByCompany();
      this.getProductsByCompanyTmp();
    })
    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang;
    // this.getRankigRangeColaboradores();
    this.getCatalogoRangoColaboradoresV1(this.country_application);

  });
    lang_perfiles.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_resultados.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_confirmaEncu.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.validarNivelUser=localStorage.getItem('levelUser_tmp');
    // console.log("nivel de Usario*************",this.validarNivelUser);

  }


  restoreData(){
    this.listaProductos = [];
    this.productosDocumentadorNormaV3=[];
    this.productosDocumentadorNormaV1=[];
    this.flagPasos = false;
    this.getEnterpriseDetail(this.idEmpresa);
    this.getProductsByCompany();
    this.getYears();
  }

  ngOnInit() {
if (this.validarNivelUser==3) {
  console.log('es usuario  ITBM+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++');

  this.btnDeletProduct=true;
}else{
  this.btnDeletProduct=false;
}
  }

  getRankingArray() {
    this.odsService.getRankingrray().subscribe((response:any) => {
      console.log('response getRankingrray',response);

     // this.rankings = response.Seleccion;
    }, error => {
      //console.log("error", error);
    })
  }

  getCatalogo_typeOfResults(broker) {
    this.odsService.getCat_typeOfResults(broker).subscribe((response:any) => {
      console.log('response getCat_typeOfResults',response);
      this.typeOfResults=response.result;
     // this.rankings = response.Seleccion;
    }, error => {
      //console.log("error", error);
    })
  }

  filterRanking(event){
    // var found = this.rankings.filter(function(item) { return item.idSelect === event.value; });
    // // this.rankEnabledCert3 = event.value;
    // this.rankingItem = found[0]['tipo'];
    // console.log('this.rankingItem',this.rankingItem);

    // this.editCompanyData(9);

  }

  revisaMailPM(){
    if(this.proyectManagerEmail.length > 0){
      if(!this.regexEmail.test(this.proyectManagerEmail)){
        this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.EMAILNOVALIDO'),this.translate.instant('ALERTS.OK'));
      }
    }
  }

  getCultureAuditCGOX(){
    let userData = JSON.parse(localStorage.getItem('userData'));
    let idiomaActual: string;
    switch(this.translate.currentLang){
      case 'es': case 'zh2': case 'tr': idiomaActual = this.translate.currentLang.toUpperCase(); break;
      default: idiomaActual = 'EN';
    }
    let datos = {
      // user: userData.user,
      lang: idiomaActual
    };
    this.linksCultureAuditCGOX = [];
    this.odsService.getCultureAuditCGOX(this.idEmpresa, datos).subscribe((respuesta:any) => {
      console.log("getCultureAuditCGOX:",respuesta);
      if(respuesta.success){
        this.linksCultureAuditCGOX = respuesta.cultureAuditV2;
      }
    });
  }

  irCACGOX(anio:number){
    let coincidencia = this.linksCultureAuditCGOX.find(item => item.fecha == anio);
    console.log("ca COGX coincidente:",coincidencia);
    window.open(coincidencia.link, '_blank');
  }

  getStatusTemplate(){
    this.programacionService.statusTemplateODS(this.idEmpresa).subscribe((respuesta:any) => {
      if (respuesta.message == "Success") {
        if(respuesta.correosFaltantes.length > 0){
          Swal.fire({
            icon: 'warning',
            title: this.translate.instant('CONSULTATABLA.CORREOMODIFMODAL'),
            confirmButtonText: this.translate.instant('ALERTS.OK'),
            confirmButtonColor: '#e40601'
          });
          this.correosFaltantes = respuesta.correosFaltantes;
          console.log("correosFaltantes:",this.correosFaltantes);

        }
      }
    });
  }

  verCorreosPendientes(idProducto:string,nombrePro:string,categoria?:any,surveyToken?:string,createdAtProduc?:any){
    console.log('idProducto:::',idProducto );
    console.log("categoria::: ", categoria);
    console.log("createdAtProduc::: ", createdAtProduc);

    localStorage.setItem('categoria',categoria);
    localStorage.setItem('tipoProct',nombrePro);
    console.log({id: this.idEmpresa, idprod: idProducto});
    if(localStorage.getItem('surveyToken') != undefined){
      localStorage.removeItem('surveyToken');
    }
    if(surveyToken != undefined){
      localStorage.setItem('surveyToken',surveyToken);
      localStorage.setItem('createdAtProduc',createdAtProduc);
    }
    // this.router.navigate(['/companies/detail',{id: this.idEmpresa, idprod: idProducto}]);
    this.router.navigate(['/companies/detail',this.idEmpresa,idProducto]);
  }

  verInfoProduc(infoProducto){
    this.clickButton=true;
    console.log("infoProducto",infoProducto);
    const dialogRef = this.dialog.open(ConfigResultComponent, {
      width: '60%',
      // height: '84%',
      data: {
        empresaId: this.idEmpresa,
        InfoGral: infoProducto,
        tipo:'infoProduct',
        nombreEmpresa:this.nombreEmpresa,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('realiza algo');
      this.getProductsByCompany();
    });

  }

  modalInfraEstructura(data:any){
    console.log("data",data);

    const dialogRef = this.dialog.open(InfraStructComponent, {
      width: '40%',
      disableClose: true,
      // height: '84%',
      data: {
        empresaId: this.idEmpresa,
        tipo:'infraEstruct',
        nombreEmpresa:this.nombreEmpresa,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('realiza algo',result);
      if (!result.infraEstruct) {
        console.log("registra producto de manera normal",data);
        this.registraProducto(data);
      }else{
        data.survey_subdomain=result.subDominio;
        this.registraProductoV2(data);
      }
      // this.getProductsByCompany();
    });

  }

registraProductoV2(data){
console.log("datos version 2",data);
  this.odsService.addProductv2(this.idEmpresa,data).subscribe((response:any) => {
    console.log(response);
    if (response.message=='Success') {
      this.modalGuardado(4);
      this.create_Infrastructure(response.productoId);
    }else{
      if(response.message == 'Success2'){
      this.temporal = false;
      this.openSuccessSnackBar(this.translate.instant('PERFILES.USUARIO.PRODUCT_REGISTERPREVIOUS'),this.translate.instant('ALERTS.OK'));
      //this.openSuccessSnackBar('Product previously registered.','OK');
    }else if(response.message == '700'){
      this.temporal = false;
      this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.CERTIFICAR_EXISTENTE'),this.translate.instant('ALERTS.OK'));
      //this.openSuccessSnackBar('Product previously registered.','OK');
    }else if(response.message == '703'){
      this.temporal = false;
      this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.CERTIFICAR_NO_TERMINADO'),this.translate.instant('ALERTS.OK'));
      //this.openSuccessSnackBar('Product previously registered.','OK');
    }else if(response.message == '701'){
      this.temporal = false;
      this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.CERTIFICAR_NO_EXISTENTE'),this.translate.instant('ALERTS.OK'));
      //this.openSuccessSnackBar('Product previously registered.','OK');
    }else if(response.message == 'saveProducto3_12'){
      this.temporal = false;
      this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.PULSOS-COMPLETOS'),this.translate.instant('ALERTS.OK'));
      //this.openSuccessSnackBar('Product previously registered.','OK');
    }else if(response.message == '722'){
      this.temporal = false;
      this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.SIN_USUARIO'),this.translate.instant('ALERTS.OK'));
      //this.openSuccessSnackBar('Product previously registered.','OK');
    }else if(response.message == 'saveProducto3_1'){
      this.temporal = false;
      this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.PRODUCT_EXIST'),this.translate.instant('ALERTS.OK'));
    }
    else{
      this.temporal = false;
      this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.PRODUCT_REGISTERFAIL'),this.translate.instant('ALERTS.OK'));
    }
    }
  //   if(response['message'] == 'Success'){
  //   if (this.idsProductosSendEmailRT.includes(this.selectSector) && this.idsInstitutosSendEmailRT.includes(this.instituto)) {
  //     this.modalEnvioCorreoRT(response);
  //   }else{
  //     this.finProcesoAgregarProducto();
  //   }
  // }

  }, error => {
    console.log(error);
  });
}

create_Infrastructure(productoId){
let data={productId:productoId};
  this.odsService.create_Infrastructure(this.idEmpresa,data).subscribe((response:any) => {
    console.log("create_Infrastructure",response);
    response.productoId=productoId;
      Swal.close();
    if(response.success == true){
    if (this.idsProductosSendEmailRT.includes(this.selectSector) && this.idsInstitutosSendEmailRT.includes(this.instituto)) {
      this.modalEnvioCorreoRT(response);
    }else{
      this.finProcesoAgregarProducto();
    }
  }else{
    Swal.fire({
      icon: 'warning',
      title: this.translate.instant('CONSULTATABLA.MODAL_ERROR_INFRA'),
      confirmButtonText: this.translate.instant('ALERTS.OK'),
    }).then((result) => {
      if (this.idsProductosSendEmailRT.includes(this.selectSector) && this.idsInstitutosSendEmailRT.includes(this.instituto)) {
        this.modalEnvioCorreoRT(response);
      }else{
        this.finProcesoAgregarProducto();
      }
    });
    // this.openSuccessSnackBar(this.translate.instant('CONSULTATABLA.MODAL_ERROR_INFRA'),this.translate.instant('ALERTS.OK'));
  }

  }, error => {
    console.log(error);
  });
}



  eliminarProduct(productoId:any,tipo:any){
    console.log('producto',productoId);
    let r = Math.random().toString(36).substring(7);
    console.log("cadena de datos aleatorios: ",r);

    let codigo=r;
    Swal.fire({
      title: this.translate.instant('CONSULTATABLA.MESSAGE3')+'<font color="red">'+ codigo+'</font>'+this.translate.instant('CONSULTATABLA.MESSAGE4'),
      icon: 'info',
      input:'text',
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonText: this.translate.instant('CONSULTATABLA.CANCELAR'),
      confirmButtonText: this.translate.instant('CONSULTATABLA.COMFIR')

    })
    .then( (borrar) => {
      console.log(borrar);
      if (borrar.value==codigo) {
            let datos={
                productoId:productoId,
              }
                this.modalGuardado(3);
            this.odsService.deleteProduct(this.idEmpresa,datos).subscribe((respuesta:backInter.actualizarCA) => {
              console.log("Entra");
              console.log(respuesta);
              Swal.close();
              this.snackBar.open(this.translateSrv.instant('CONSULTATABLA.SUCC_DELE_PROD'), "", {
                duration: 2000,
              });
                this.getProductsByCompany();
            }, error => {
              console.log("error", error);

            })

      }
      else{
        if(!borrar.dismiss){
          Swal.fire({
          icon: 'error',
          title: this.translate.instant('CONFIRMACION.BOTONES-MODALES.ELIMINAR.ERRORNOMBREEMPRESA'),
          showConfirmButton: true,
          confirmButtonText: 'Ok'
          })
        }

      }
    });

  }

  verCloud(idProducto:string){
    console.log({id: this.idEmpresa, idprod: idProducto});
    // this.router.navigate(['/companies/detail',{id: this.idEmpresa, idprod: idProducto}]);
    this.router.navigate(['/companies/detail',this.idEmpresa,idProducto,'file-manager']);
  }

  logSendgrind(idProducto:string,fechaprod:any, idPlantilla:any, tipoProducto:any){
    console.log({id: this.idEmpresa, idprod: idProducto, fechaprod:fechaprod, idplantilla:idPlantilla});
    this.router.navigate(['/companies/detail',this.idEmpresa,idProducto,fechaprod,idPlantilla,tipoProducto,'sendgrind-log']);
  }

  verDetallesRT(idProducto:string){
    const dialogRef = this.dialog.open(InfoRTComponent, {
      width: '75%',
      data: {
        empresaId: this.idEmpresa,
        productoId: idProducto
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  verConfigResult(idProducto:string,tokenConfig:string,producto?:any){
    const dialogRef = this.dialog.open(ConfigResultComponent, {
      width: '85%',
      height: '95%',
      disableClose: true,
      data: {
        empresaId: this.idEmpresa,
        productoId: idProducto,
        tokenConfig:  tokenConfig,
        tipo:'confResult',
        infoProducto:producto,
        instituto:this.instituto,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  ResultEmprising(idProducto:string,tokenConfig:string, fileFlags:any){
    const dialogRef = this.dialog.open(ResultEmprisingComponent, {
      width: '50%',
      height: '40%',
      data: {
        empresaId: this.idEmpresa,
        productoId:idProducto,
        token:tokenConfig,
        fileFlags:fileFlags,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }


actualizarCA(idProducto:any, bandera?:any) {
  let mensaje: string;
  let cerrar: string;
  let errorSinCertificar: string;

  let mensaje_action:string;
  let error_Action:string;
  this.translateSrv.get('PERFILES.EMPRESA.ACTUALIZARCA.SUCCESS').subscribe((res: string) => { mensaje = res; });
  this.translateSrv.get('PERFILES.EMPRESA.ACTUALIZARCA.CERRAR').subscribe((res: string) => { cerrar = res; });
  this.translateSrv.get('PERFILES.EMPRESA.ACTUALIZARCA.ERROR').subscribe((res: string) => { errorSinCertificar = res; });

  this.translateSrv.get('PERFILES.EMPRESA.ACTUALIZARCA.SUCCESS_ACTION').subscribe((res: string) => {mensaje_action = res; });
  this.translateSrv.get('PERFILES.EMPRESA.ACTUALIZARCA.ERROR_ACTION').subscribe((res: string) => { error_Action = res; });
  if(bandera == 1){
    mensaje= mensaje_action;
    errorSinCertificar = error_Action;
  }
  let datos={
    productoId:idProducto
  }
  this.odsService.actualizarCA(this.idEmpresa,datos).subscribe((respuesta:backInter.actualizarCA) => {
    console.log("Entra");
    if(respuesta.message=="200"){
      Swal.fire({
        icon: 'success',
        title: mensaje,
        confirmButtonText: cerrar,
        confirmButtonColor: '#e40601'
      });
    }
    console.log(respuesta);
  }, error => {
    console.log("error", error);
    if(error.error.message=="Product Not Found"){
      Swal.fire({
        icon: 'error',
        title: errorSinCertificar,
        confirmButtonText: cerrar,
        confirmButtonColor: '#e40601'
      });
    }
  })
}
cambioValor(){
  this.clickButton=true;
  }
private getEnterpriseDetail(idEnterprise : string) {
  this.odsService.getEnterpriseDetail(idEnterprise)
  .subscribe((response:any) => {
    console.log("getEnterpriseDeailt");
    console.log(response);
    this.aplicaRanking=response['data']['ranking'];

    this.enterpriseData = response['data'];
    this.instituto = response['data']['institutoEmpresa'];

    this.nombreEmpresa = this.enterpriseData['nombreEmpresa'];
    this.sectorName = this.enterpriseData['sector'];
    this.subsectorName = this.enterpriseData['subSector'];
    this.rankingName = this.enterpriseData['tipo'];
    this.tipoName = this.enterpriseData['tipo'];
    this.codigoDeProyecto=this.enterpriseData['codigoProyecto'];
    this.country_application= this.enterpriseData['country_application'];
    this.getPlantillas(this.enterpriseData['institutoEmpresa']);
    this.getProjectManagerProductos(this.instituto);
    localStorage.setItem('instituto_correos',''+this.instituto);
    console.log(response['data']['ranking']);
    // this.getRankigRangeColaboradores();
    this.getCatalogoRangoColaboradoresV1(this.country_application);
    this.getIdiomasTemplateEmailRt(this.instituto);
    this.getCatalogo_typeOfResults(this.instituto);
    if(this.instituto == 5){
      console.log("Es instituto de turquia");
    }

    this.getProducts();
    //si la empresa es de cgo express se llama este servicio
    if(response.data.idCgoExprs != undefined){
      this.getCultureAuditCGOX();
    }
  }, error => {
    console.log("error", error);
  });
}

private getProducts() {
  this.odsService.getProductsArray().subscribe((respuesta: any) => {
    console.log("Respuestas productos");
    console.log(respuesta);
    //console.log("Instituto "+this.instituto)*/

    respuesta.productos.forEach(producto => {
      let categoria:any = {};

      switch (producto.idProducto) {
        case 1: case 2: case 3: case 4: case 6: case 8: case 17: case 18:  case 53: case 54: case 56:  case 59: case 60: //certificar, medir, nom35,pulsecheck,focus area,ca, resultados

        if( ![3, 5, 8, 18, 19, 22].includes(this.instituto) ){  //si no es instituto china o turquia o izzi agrega todos los casos de producto
          categoria = {
            nombre: producto.nombreProducto,
            productos: [
              {idProducto: producto.idProducto, activo: true}
            ]
          };
        }
        else{

          if(this.instituto != 8){ //si es instituto china o turquia solo agrega el certificar y culture audit
            if(producto.idProducto == 1 || producto.idProducto == 8 || producto.idProducto == 6 ){
              if(this. instituto == 5 && producto.idProducto == 8){
                categoria = {
                  nombre: producto.nombreProducto,
                  productos: [
                    {idProducto: producto.idProducto, activo: false}
                  ]
                };
              }else{
                if(this.instituto != 18){
                  categoria = {
                    nombre: producto.nombreProducto,
                    productos: [
                      {idProducto: producto.idProducto, activo: true}
                    ]
                  };
                }
              }

            }
          }

          if(this.instituto == 8){  //si es instituto izzi agrega certificar y nom35
            if(producto.idProducto == 1 ){
              categoria = {
                nombre: producto.nombreProducto,
                productos: [
                  {idProducto: producto.idProducto, activo: true}
                ]
              };
            }
            if(producto.idProducto == 2 ){ //Si el producto es MEDIR y el instituto es IZZI se agrega
              categoria = {
                nombre: producto.nombreProducto,
                productos: [
                  {idProducto: producto.idProducto, activo: true}
                ]
              };
            }
            if(producto.idProducto == 3 ){ //Si el producto es pulse y el instituto es IZZI se agrega
              categoria = {
                nombre: producto.nombreProducto,
                productos: [
                  {idProducto: producto.idProducto, activo: true}
                ]
              };
            }

            if(producto.idProducto == 4 ){ //Si el producto es pulse y el instituto es IZZI se agrega
              categoria = {
                nombre: producto.nombreProducto,
                productos: [
                  {idProducto: producto.idProducto, activo: true}
                ]
              };
            }


            if(producto.idProducto == 17){
              categoria = {
                nombre: producto.nombreProducto,
                productos: [
                  {idProducto: producto.idProducto, activo: true}
                ]
              };
            }
          }

          if (this.instituto == 19) {
            categoria={};
            if(producto.idProducto == 2 ){ //Si el producto es MEDIR y el instituto es innotion se agrega
              categoria = {
                nombre: producto.nombreProducto,
                productos: [
                  {idProducto: producto.idProducto, activo: true}
                ]
              };
            }



          }

          if(producto.idProducto == 2 && this.instituto == 5){ //Si el producto es Medir y el instituto es turkia se agrega
            categoria = {
              nombre: producto.nombreProducto,
              productos: [
                {idProducto: producto.idProducto, activo: true}
              ]
            };
          }
          if(producto.idProducto == 2 && [3, 22].includes(this.instituto) ){ //Si el producto es Medir y el instituto es HK se agrega
            categoria = {
              nombre: producto.nombreProducto,
              productos: [
                {idProducto: producto.idProducto, activo: true}
              ]
            };
          }

          // if(producto.idProducto ==  68 && this.instituto == 3){ //Si el producto es Medir y el instituto es HK se agrega
          //   categoria = {
          //     nombre: producto.nombreProducto,
          //     productos: [
          //       {idProducto: producto.idProducto, activo: true}
          //     ]
          //   };
          // }

          if(producto.idProducto == 2 && this.instituto == 18){ //Si el producto es Medir y el instituto es AMCO se agrega
            categoria = {
              nombre: producto.nombreProducto,
              productos: [
                {idProducto: producto.idProducto, activo: true}
              ]
            };
          }
          if(producto.idProducto == 8 && this.instituto == 18){ //Si el producto es CA y el instituto es AMCO se agrega
            categoria = {
              nombre: producto.nombreProducto,
              productos: [
                {idProducto: producto.idProducto, activo: true}
              ]
            };
          }
          if(producto.idProducto == 4 && this.instituto == 5){ //Si el producto es pulse y el instituto es turkia se agrega
            categoria = {
              nombre: producto.nombreProducto,
              productos: [
                {idProducto: producto.idProducto, activo: true}
              ]
            };
          }
          if(producto.idProducto == 17 && this.instituto == 5){ //Si el producto es Resultados y el instituto es turkia se agrega
            categoria = {
              nombre: producto.nombreProducto,
              productos: [
                {idProducto: producto.idProducto, activo: true}
              ]
            };
          }
          if(producto.idProducto == 54 && [3,22].includes(this.instituto)){ //Si el producto es Action go  y el instituto es turkia se agrega
            categoria = {
              nombre: producto.nombreProducto,
              productos: [
                {idProducto: producto.idProducto, activo: true}
              ]
            };
          }
          if(producto.idProducto == 54 && this.instituto == 5){ //Si el producto es Action go  y el instituto es turkia se agrega
            categoria = {
              nombre: producto.nombreProducto,
              productos: [
                {idProducto: producto.idProducto, activo: true}
              ]
            };
          }
          if(producto.idProducto == 4 && [3,22].includes(this.instituto)){ //Si el producto es pulse y el instituto es HK se agrega
            categoria = {
              nombre: producto.nombreProducto,
              productos: [
                {idProducto: producto.idProducto, activo: true}
              ]
            };
          }
          if(producto.idProducto == 17 && [3,5,22].includes(this.instituto)){ //Si el producto es resultados y el instituto es HK o TR
            categoria = {
              nombre: producto.nombreProducto,
              productos: [
                {idProducto: producto.idProducto, activo: true}
              ]
            };
          }

        }
        if(this.instituto ==1 && producto.idProducto ==18 ){
          categoria = {
            nombre: producto.nombreProducto,
            productos: [
              {idProducto: producto.idProducto, activo: true}
            ]
          };
        }

        if(producto.idProducto == 60 && this.instituto == 5){ //Si el producto es emprising y el instituto es TR se agrega
          categoria = {
            nombre: producto.nombreProducto,
            productos: [
              {idProducto: producto.idProducto, activo: true}
            ]
          };
        }

      if(producto.idProducto == 60 && [3,22].includes(this.instituto)){ //Si el producto es emprising y el instituto es HK se agrega
          categoria = {
            nombre: producto.nombreProducto,
            productos: [
              {idProducto: producto.idProducto, activo: true}
            ]
          };
        }

        if(!this.objetoVacio(categoria)){
          this.listaProductos.push(categoria);
        }
        break;



        case 9: case 30: case 31: case 32: case 33: case 61: case 62:  case 76: case 77: case 78: case 80://casos para productos culture audit adicionales: version2 y training
        // case 9: case 10: case 30: case 31: case 32: case 33: case 44: case 45: case 46: case 48: case 49: case 61: case 62: case 64: case 65: case 66: case 67: case 71:case 72:case 73://casos para productos culture audit adicionales: version2 y training

          if( ![3,5,8,18,19,22].includes(this.instituto) ){  //si no es instituto china, turquia o izzi agrega todos los casos de producto
            categoria = this.listaProductos[5];  //obtiene la lista de productos culture audit
            if(producto.idProducto == 9){ //cuando es el caso 9, CA5.0, se vacia el arreglo y se inicializa con este producto
              // categoria.productos = [{
              //   idProducto: producto.idProducto,
              //   activo: true
              // }];
              categoria.productos = [];
            }
            if(producto.idProducto == 61 ||  producto.idProducto == 62 || producto.idProducto == 80){  //filtro de producto ca training para instituto mx y cayc
              if(this.instituto == 2){
                categoria.productos.push({
                  idProducto: producto.idProducto,
                  activo: true
                });
              }
            }


            if(producto.idProducto == 10 || producto.idProducto == 44 || producto.idProducto == 45 || producto.idProducto == 46 || producto.idProducto == 48 || producto.idProducto == 49 || producto.idProducto == 64 || producto.idProducto == 65 || producto.idProducto == 66 || producto.idProducto == 67 || producto.idProducto == 71 || producto.idProducto == 72 || producto.idProducto == 73 || producto.idProducto == 76|| producto.idProducto == 77 || producto.idProducto == 78){  //filtro de producto ca training para instituto mx y cayc
              if(this.instituto == 1){
                categoria.productos.push({
                  idProducto: producto.idProducto,
                  activo: true
                });
              }
            }
            // else{
            //   categoria.productos.push({
            //     idProducto: producto.idProducto,
            //     activo: true
            //   });
            // }
          } //Primer if
          else{
            if(this.instituto == 5){
              categoria = this.listaProductos[4];  //obtiene la lista de productos culture audit
            }
            else{
              categoria = this.listaProductos[1];
            }
            if(producto.idProducto == 9 && [3,22].includes(this.instituto)){  //filtro de producto ca v2 para instituto china
              // console.log("Lo agrego brief and");
              categoria = this.listaProductos[4];
              categoria.productos = [];
              categoria.productos.push({
                idProducto: producto.idProducto,
                activo: true
              });
            }

            if(producto.idProducto == 9 && this.instituto == 5){  //filtro de producto ca v2 para instituto china
              // console.log("Lo agrego brief and");
              categoria = this.listaProductos[4];
              categoria.productos.push({
                idProducto: producto.idProducto,
                activo: true
              });
            }
          }
        break;
console.log(this.listaProductos[1]);
case 11:  //casos para productos medir adicionales
// case 11: case 12: case 13: case 14: case 15: case 16: case 41:  //casos para productos medir adicionales
if( ![1,2,3,5,8,18,19,22].includes(this.instituto) ){  //si no es instituto mx, china, CAYC, turquia o izzi, agrega todos los casos de producto
  categoria = this.listaProductos[1];
  categoria.productos=[];
  categoria.productos.push({
    idProducto: producto.idProducto,
    activo: true
  });
}
break;
case 41:  //casos para productos medir v3
  const brokersSinMedirAnterior = [1, 2, 3, 5, 8, 22];  //MX, CAYC, HK, TR, IZZI
  if(brokersSinMedirAnterior.includes(this.instituto)) {
    categoria = this.listaProductos[1];  //obtiene la lista de productos medir
    categoria.productos=[]; //se vacia la lista, solo se deja el actual
    categoria.productos.push({
      idProducto: producto.idProducto,
      activo: true
    });
  }else if (this.instituto == 18) {   //CASO AMCO
    categoria = this.listaProductos[0];  //obtiene la lista de productos medir
    categoria.productos=[];
    categoria.productos.push({
      idProducto: producto.idProducto,
      activo: true
    });
  }else if(this.instituto == 19){
    //Si el producto es MEDIR y el instituto es innotion se agrega
    console.log("entro instituo 19 S",this.listaProductos);

      categoria = this.listaProductos[0];
      categoria.productos = [];
      categoria.productos.push({
        idProducto: producto.idProducto,
        activo: true
      });
  }
  else{
    categoria = this.listaProductos[1];
    categoria.productos.push({
      idProducto: producto.idProducto,
      activo: true
    });
  }

break;

case 63: //caso para producto nom35 beter y nom35 plata
if(this.instituto == 1 || this.instituto == 8){
  if(this.instituto == 1) categoria = this.listaProductos[2];  //obtiene la lista de productos nom35
  if(this.instituto == 8) categoria = this.listaProductos[2];  //obtiene la lista de productos nom35
  categoria.productos.push({
    idProducto: producto.idProducto,
    activo: true
  });
}
break;

// case 19: case 39: //caso para producto nom35 beter y nom35 plata
// if(this.instituto == 1 || this.instituto == 8){
//   if(this.instituto == 1) categoria = this.listaProductos[2];  //obtiene la lista de productos nom35
//   if(this.instituto == 8) categoria = this.listaProductos[2];  //obtiene la lista de productos nom35
//   categoria.productos.push({
//     idProducto: producto.idProducto,
//     activo: true
//   });
// }
// break;

case 20:  //caso para producto certificar v2
if(this.instituto != 1 && this.instituto != 18){  //si no es instituto México agrega todos los casos de producto
categoria = this.listaProductos[0];  //obtiene la lista de productos certificar
categoria.productos = []; //se vacia para borrar el certificar 1
categoria.productos.push({
  idProducto: producto.idProducto,
  activo: true
});
}
break;
case 40:  //caso para producto certificar v2.1
if(this.instituto != 18){
  categoria = this.listaProductos[0];  //obtiene la lista de productos certificar
  if(this.instituto == 1 || this.instituto == 2){  //si es instituto MX o CAYC le borra el primer certificar y le deja solo el 3.0
    categoria.productos = []; //se vacia para borrar el certificar 1
  }
  categoria.productos.push({
    idProducto: producto.idProducto,
    activo: true
  });
  // console.log("categoria 3.0",categoria);
}

break;
// case 69:  //caso para producto certificar v2.1
// if(this.instituto == 2){
//   categoria = this.listaProductos[0]
//   categoria.productos.push({
//     idProducto: producto.idProducto,
//     activo: true
//   });
//   // console.log("categoria 3.0",categoria);
// }

break;

case 27:  //caso para producto certificar IZZI para instituto IZZI
if(this.instituto == 8){  //si es instituto nuevo todos los casos de producto
  categoria = this.listaProductos[0];  //obtiene la lista de productos certificar
  categoria.productos = []; //se vacia para borrar los productos certificar
  categoria.productos.push({
    idProducto: producto.idProducto,
    activo: true
  });
}
break;
case 70:  //caso para producto resultados goFlow
if(this.instituto ==1 || this.instituto == 2){
  categoria = this.listaProductos[6];
  categoria.productos.push({
    idProducto: producto.idProducto,
    activo: true
  });
}
if([3,22].includes(this.instituto)){
  console.log(categoria);

  categoria = this.listaProductos[5];
  categoria.productos.push({
    idProducto: producto.idProducto,
    activo: true
  });
}

break;
case 28: case 29: case 37: case 50: case 51: case 55: case 74:
  // console.log("catagoria ");
  // console.log(this.listaProductos);
  if(this.instituto == 5){  //TR
    categoria = this.listaProductos[4];  //obtiene la lista de productos culture audit
    if(producto.idProducto == 28 || producto.idProducto == 29 || producto.idProducto == 74){  //filtro de producto ca v2 para instituto TR
      categoria.productos.push({
        idProducto: producto.idProducto,
        activo: true
      });
    }
  }else if([3,22].includes(this.instituto)){  //HK
    categoria = this.listaProductos[4];  //obtiene la lista de productos culture audit
    if(producto.idProducto == 37){  //filtro de producto ca sp para instituto china
      if(categoria.productos.length > 0){
        categoria.productos = [];
      }
      categoria.productos.push({
        idProducto: producto.idProducto,
        activo: true
      });
    }
    if(producto.idProducto == 50 || producto.idProducto == 51){  //filtro de producto ca 5.0 y 4all para instituto china
      categoria.productos.push({
        idProducto: producto.idProducto,
        activo: true
      });
    }
  } else if(this.instituto == 18){  //AMCO
    categoria = this.listaProductos[1];  //obtiene la lista de productos culture audit
    categoria.productos = [];
    if(producto.idProducto == 55){  //filtro de producto ca v2 para instituto TR
      categoria.productos.push({
        idProducto: producto.idProducto,
        activo: true
      });
    }
  }
break;
// case 38: //Categoria action plan
// console.log("catagoria action plan");
// console.log(this.listaProductos);
//
//
// break;

case 42:  //pulse check 3.0
  //si no es instituto china o izzi agrega todos los casos de producto
  // console.log('this.listaProductos[3]',this.listaProductos);
  if(this.instituto==5) {
    categoria = this.listaProductos[2];  //obtiene la lista de productos pulse
    categoria.productos=[];
    categoria.productos.push({
      idProducto: producto.idProducto,
      activo: true
    });
  }else if ([3,22].includes(this.instituto)) {
    categoria = this.listaProductos[2];  //obtiene la lista de productos pulse
    categoria.productos=[];
    categoria.productos.push({
      idProducto: producto.idProducto,
      activo: true
    });
  }else if (this.instituto==8) {
    categoria = this.listaProductos[3];  //obtiene la lista de productos pulse
    categoria.productos=[];
    categoria.productos.push({
      idProducto: producto.idProducto,
      activo: true
    });
  }else{
    if(this.instituto != 18 && this.instituto != 19){
      categoria = this.listaProductos[3];  //obtiene la lista de productos pulse
      categoria.productos=[];
      categoria.productos.push({
        idProducto: producto.idProducto,
        activo: true
      });
    }
  }

break;
case 43:  //Focus Area 3.0
  //si no es instituto china o izzi agrega todos los casos de producto
  // console.log('this.listaProductos[3]',this.listaProductos);
  if(this.instituto != 18 && this.instituto != 8 && this.instituto != 19 ){
    if([3,5,22].includes(this.instituto)){
      categoria = this.listaProductos[3]; //obtiene la lista de productos focus area
    } else{
      categoria = this.listaProductos[4]; //obtiene la lista de productos focus area
    }
    categoria.productos=[];
    categoria.productos.push({
      idProducto: producto.idProducto,
      activo: true
    });
  }
break;
case 57: case 58: //caso para producto nom35 beter y nom35 plata
console.log('entro el caso de los producto nuevos de amco ');
if (this.instituto==1) {
  console.log(this.listaProductos);
  categoria = this.listaProductos[10];
  categoria.productos.push({
    idProducto: producto.idProducto,
    activo: true
  });

}
break;


case 75:  // GPTW + GCTI
if(this.instituto == 1){
  categoria = this.listaProductos[0];  //obtiene la lista de productos certificar
  categoria.productos.push({
    idProducto: producto.idProducto,
    activo: true
  });
  // console.log("categoria 3.0",categoria);
}


default:
break;
}
// console.log("productoLeido:",producto.idProducto,"listaProductosActual:",this.listaProductos);
});
console.log("refDet:",JSON.parse(JSON.stringify(this.listaProductos)));
if (this.instituto!=1) {
    this.listaProductos.splice(10,2);
}


console.log("Lista productos:",this.listaProductos);
}, error => {
  console.log("error", error);
});

// if(this.instituto != 1){
// this.listaProductos.pop();
// }


}

objetoVacio(obj) {
  for(let prop in obj) {
    if(obj.hasOwnProperty(prop)) {
      return false;
    }
  }
  return JSON.stringify(obj) === JSON.stringify({});
}

private getProductsByCompanyTmp() {
  this.odsService.getProductosEmpresa(this.idEmpresa).subscribe((respuesta:any) => {
    console.log("Dude tmp");
    console.log(respuesta);

  }, error => {
    console.log("error", error);
  })
}
showActionPlan:boolean=false;
private getProductsByCompany() {
  this.odsService.getProductosEmpresa(this.idEmpresa).subscribe((respuesta:backInter.infoProductos) => {
    this.listaAction=[];
    this.listaLeaderGo=[];
    this.listaProductosCultureAuditV2 = [];
    this.listaProductosCultureAuditICCA = [];
    this.listaProductosCultureBrief = [];
    console.log("Productos adquiridos");
    console.log(respuesta);
    this.productosContratadosInter = respuesta;

    this.productoNorma_tmp=this.productosContratadosInter.productosNorma35;
    this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
      if(producto.tipo == 9){
        this.showActionPlan=true;
        this.listaAction.push(producto);
      }
      if(producto.tipo != 9 && producto.tipo != 19 && producto.tipo != 20 && producto.tipo != 21){
          this.listaProductosCultureAuditV2.push(producto);
            this.verListCultureAuditV2=true;
      }
      console.log('listaProductosCultureAuditV2',this.listaProductosCultureAuditV2);


      if(producto.tipo == 19){
          this.listaProductosCultureAuditICCA.push(producto);

      }

      if(producto.tipo == 20||producto.tipo == 21){
          this.listaProductosCultureBrief.push(producto);
          this.verListCultureBrief=true;
      }
    });

console.log('listaProductosCultureBrief',this.listaProductosCultureBrief);

    this.productosContratadosInter.productosCertificar.forEach(product => {
      // console.log("producto",product);

      if(product.idProducto == 40 || product.idProducto == 20 || product.idProducto == 1 || product.idProducto == 75){
        this.mostrarMenuCertificar=true;
        // console.log("Encontro tan solo un certificar ");
      }else{
        // console.log("No encontro tan solo un certificar ");
      }
    });

    let contador=0;
    this.listaAudit_aux=this.productosContratadosInter.productosCultureAuditV2;
    this.listaAudit_aux.forEach(producto => {
        if(producto.tipo == 9){
          this.productosContratadosInter.productosCultureAuditV2.splice(contador,1);
        contador++;
      }
    });

    this.listaAudit_aux=this.productosContratadosInter.productosCultureAuditV2;
    contador=0;
    this.listaAudit_aux.forEach(producto => {
        if(producto.tipo == 9){
          this.productosContratadosInter.productosCultureAuditV2.splice(contador,1);
        }
        contador++;
    });


    // console.log(this.listaAction);


    if(this.productosContratadosInter.productosPulseCheck){
      this.productosContratadosInterPulse = respuesta;
      this.pulseCheckAños();
    }else{
      this.pulseCheckAños();
    }


this.productosContratadosInter.productosDocumentador.forEach(documentador => {
  if (documentador.idProducto==63) {
    this.productosDocumentadorNormaV3.push(documentador);
  }else{
    this.productosDocumentadorNormaV1.push(documentador);
  }
});

console.log('this.productosDocumentadorNormaV3',this.productosDocumentadorNormaV3);
console.log('this.productosDocumentadorNormaV1',this.productosDocumentadorNormaV1);

    // if(this.productoNorma_tmp.length >0){
    //   this.statusProductoNorma35=true;
    // }else{
    //   this.statusProductoNorma35=false;
    // }
    console.log("EStatus norma"+this.statusProductoNorma35);
    this.ordenaSeccionesProductos();
    this.filtraProductosMedir();
  }, error => {
    console.log("error", error);
  })
}

ordenaSeccionesProductos(){
  let seccionesNoPermitidas:any[]=[];
  let seccionesPermitidas:any[]=[];

  if(this.productosContratadosInter.productosCertificar.length > 0){
    this.productosContratadosInter.productosCertificar.forEach(producto => {
      producto.secciones.sort( (a,b) => {
        if(a.orden > b.orden){
          return 1;
        } else{
          return -1;
        }
      });
    });
  }

  if(this.productosContratadosInter.productosMedir2.length > 0){
    this.productosContratadosInter.productosMedir2.forEach(producto => {
      producto.secciones.sort( (a,b) => {
        if(a.orden > b.orden){
          return 1;
        } else{
          return -1;
        }

      });

      producto.secciones.forEach(produc => {
        if (produc.nombre=="NPS" || produc.nombre=="Control") {
          seccionesNoPermitidas.push(produc);
          // console.log(seccionesNoPermitidas);

        }else{
          seccionesPermitidas.push(produc);
          // console.log(seccionesPermitidas);

        }
      });
      this.seccionesMedirMejorado.push(seccionesPermitidas);
      console.log(this.seccionesMedirMejorado);
    });


  }
}

private filtraProductosMedir(){

  this.listaProdsCertificar = [];
  this.listaProdsGoflow = [];
  this.listaProdsNorma35 = [];
  this.listaProdsExpress = [];
  this.listaProdsMedir = [];
  this.listaProdsPulse = [];
  this.listaProdsFocus = [];
  this.listaProdsLeaderGo = [];
  this.listaProdsActionGo = [];
  this.listaProdsCerAmco = [];
  this.listaProdsCerEmprising = [];
  //arreglos certificar
  let arrayCert_1:any[] = [];
  let arrayCert_2:any[] = [];
  let arrayCert_3:any[] = [];
  let arrayCert_4:any[] = [];
  let arrayCert_5:any[] = [];
  let arrayCert_6:any[] = [];
  let arrayGoFlow:any[] = [];
  //declaración de arreglos de productos medir
  let arrayMedir_0:any[] = [];
  let arrayMedir_1:any[] = [];
  let arrayMedir_2:any[] = [];
  let arrayMedir_3:any[] = [];
  let arrayMedir_4:any[] = [];
  let arrayMedir_5:any[] = [];
  let arrayMedir_6:any[] = [];
  let arrayMedir_7:any[] = [];
  //declaración de arreglos de productos pulse
  let arrayPulse_0:any[] = [];
  let arrayPulse_1:any[] = [];
  let arrayFocus_0:any[] = [];
  let arrayFocus_1:any[] = [];
  let arrayLeaderGo:any[] = [];
  let arrayActionGo:any[] = [];
  let arrayCerAmco:any[] = [];
  let arrayCerAmcoTra:any[] = [];
  let arrayCerAmcoPrime:any[] = [];
  let arrayCerEmprising:any[] = [];
  let arrayNorma35:any[] = [];
  let arrayNorma35Better:any[] = [];
  let arrayNorma35Plata:any[] = [];
  let arrayNorma35V3:any[] = [];

  //filtrado de certificar
  this.productosContratadosInter.productosCertificar.forEach((producto:any) => {
    if(this.idsProductosCert3Falsos.findIndex(item => item.id == producto.idProducto) == -1){ //si el id del producto no esta en el arreglo
      this.correosFaltantes.forEach(faltante => {
        if(producto.idCertificar == faltante.productoId){
          producto.correoPendiente = true;
        }
      });
      switch (producto.tipo) {
        case 1: arrayCert_1.push(producto); break;
        case 2: arrayCert_2.push(producto); break;
        case 3: arrayCert_3.push(producto); break;
        case 4: arrayCert_4.push(producto); break;
        case 9: arrayCert_5.push(producto); break;
        case 11: arrayCert_6.push(producto); break;
      }
    }
    else{
      // console.log('producto.idProducto',producto.idProducto);

      switch (producto.idProducto) {
        case 41:  //medir 3.0
        arrayMedir_7.push(producto);
        this.idsProductosCert3Falsos[0].activo = true;
        break;
        case 42:  //pulse 3.0
        arrayPulse_1.push(producto);
        this.idsProductosCert3Falsos[1].activo = true;
        break;
        case 43:  //pulse 3.0
        // console.log('jhgdgfdgdutdtk');
        arrayFocus_1.push(producto);
        this.idsProductosCert3Falsos[2].activo = true;
        break;
        case 53:  //LeaderGo 3.0
        // console.log('jhgdgfdgdutdtk');

        arrayLeaderGo.push(producto);
        this.idsProductosCert3Falsos[3].activo = true;
        break;
        case 54:  //ActionGo 3.0
        // console.log('jhgdgfdgdutdtk');

        arrayActionGo.push(producto);
        this.idsProductosCert3Falsos[4].activo = true;
        break;
        case 56:  //Certificar amco
        arrayCerAmco.push(producto);
        this.idsProductosCert3Falsos[5].activo = true;
        break;
        case 57:  //Certificar amco Trabajo Digno
        arrayCerAmcoTra.push(producto);
        this.idsProductosCert3Falsos[6].activo = true;
        break;
        case 58:  //Certificar amco Primer empleo
        arrayCerAmcoPrime.push(producto);
        this.idsProductosCert3Falsos[7].activo = true;
        break;
        case 60:  //Certificar emprising
        arrayCerEmprising.push(producto);
        this.idsProductosCert3Falsos[8].activo = true;
        break;
        case 70:  //Certificar amco Primer empleo
        arrayGoFlow.push(producto);
        this.idsProductosCert3Falsos[9].activo = true;
        break;
      }
    }
  });
  //filtrado de medir
  this.productosContratadosInter.productosMedir.forEach(producto => {
    arrayMedir_0.push(producto);
  });

  this.productosContratadosInter.productosMedir2.forEach(producto => {
    switch(producto.tipo){
      case 1: arrayMedir_1.push(producto); break;
      case 2: arrayMedir_2.push(producto);break;
      case 3: arrayMedir_3.push(producto); break;
      case 4: arrayMedir_4.push(producto); break;
      case 5: arrayMedir_5.push(producto); break;
      case 6: arrayMedir_6.push(producto); break;
    }
  });

  //filtrado de pulse
  this.productosContratadosInter.productosPulseCheck.forEach(producto => {
    arrayPulse_0.push(producto);
  });
//filtrado de FocusArea
  this.productosContratadosInter.productosFocusArea.forEach(producto => {
    arrayFocus_0.push(producto);
  });

  this.productosContratadosInter.productosCGOExpress.forEach(producto => {
    this.listaProdsExpress.push(producto);
  });
  this.productosContratadosInter.productosNorma35.forEach(producto => {
    console.log('this.correosFaltantes',this.correosFaltantes);

    this.correosFaltantes.forEach(faltanteCorr => {
      if(producto.idNorma35 == faltanteCorr.productoId){
        producto.correoPendiente = true;
        console.log('Producto',producto);

      }
    });

    if (producto.tipo==1) {
      arrayNorma35.push(producto);
    }else if(producto.tipo==2){
      arrayNorma35Better.push(producto);
    }else if(producto.tipo==3){
      arrayNorma35Plata.push(producto);

    }else if(producto.tipo==4){
      arrayNorma35V3.push(producto);

    }





  });

  this.listaProdsNorma35.push(
    {id:3, lista: arrayNorma35},
    {id:19, lista: arrayNorma35Better},
    {id:39, lista: arrayNorma35Plata},
    {id:63, lista: arrayNorma35V3},
  );
 // Se ordena los productos por fecha de mayor a menor
  arrayCert_1.sort( (a,b) => {if(a.fechaCertificar < b.fechaCertificar){return 1;} else{return -1;}});
  arrayCert_2.sort( (a,b) => {if(a.fechaCertificar < b.fechaCertificar){return 1;} else{return -1;}});
  arrayCert_3.sort( (a,b) => {if(a.fechaCertificar < b.fechaCertificar){return 1;} else{return -1;}});
  arrayCert_4.sort( (a,b) => {if(a.fechaCertificar < b.fechaCertificar){return 1;} else{return -1;}});
  arrayCert_5.sort( (a,b) => {if(a.fechaCertificar < b.fechaCertificar){return 1;} else{return -1;}});
  arrayCert_6.sort( (a,b) => {if(a.fechaCertificar < b.fechaCertificar){return 1;} else{return -1;}});

  this.listaProdsCertificar.push(
    {id:1, lista: arrayCert_1},
    {id:20, lista: arrayCert_2},
    {id:27, lista: arrayCert_3},
    {id:40, lista: arrayCert_4},
    {id:69, lista: arrayCert_5},
    {id:75, lista: arrayCert_6},
  );

  this.listaProdsCerAmco.push(
    {id:56, lista: arrayCerAmco},
    {id:57, lista: arrayCerAmcoTra},
    {id:58, lista: arrayCerAmcoPrime},
  );
  this.listaProdsCerEmprising.push(
    {id:60, lista: arrayCerEmprising},
  );

  this.listaProdsGoflow.push(
    {id:70, lista: arrayGoFlow},
  );

  if (this.listaProdsCerAmco[0].lista.length>0 || this.listaProdsCerAmco[1].lista.length>0 || this.listaProdsCerAmco[2].lista.length>0 ) {
    this.mostrarProdsCerAmco=true;
  }

  this.listaProdsMedir.push(
    {id:2, lista: arrayMedir_0},
    {id:11, lista: arrayMedir_1},
    {id:12, lista: arrayMedir_2},
    {id:13, lista: arrayMedir_3},
    {id:14, lista: arrayMedir_4},
    {id:15, lista: arrayMedir_5},
    {id:16, lista: arrayMedir_6},
    {id:41, lista: arrayMedir_7}, //medir 3.0
  );

  this.listaProdsPulse.push(
    {id:4, lista: arrayPulse_0},
    {id:42, lista: arrayPulse_1},
  );
  this.listaProdsFocus.push(
    {id:6, lista: arrayFocus_0},
    {id:43, lista: arrayFocus_1},
  );

  this.listaProdsLeaderGo.push(
    {id:53, lista: arrayLeaderGo},
  );
  this.listaProdsActionGo.push(
    {id:54, lista: arrayActionGo},
  );
if(this.listaProdsFocus.length>0){
  this.focusAreaAñosMenus();
}
  console.log("listaProdsCertificar:",this.listaProdsCertificar);
  // console.log("listaProdsMedir:",this.listaProdsMedir);
  // console.log("listaProdsPulse:",this.listaProdsPulse);
  // console.log("listaProdsFocus:",this.listaProdsFocus);
  // console.log("Nueva lista Prods LeaderGo:******",this.listaProdsLeaderGo);
  // console.log("Nueva lista Prods ActionGo:******",this.listaProdsActionGo);
  // console.log("Nueva lista Prods Certificares amco nuevos :******",this.listaProdsCerAmco);
  // console.log("Nueva lista Prods listaProdsCerEmprisings :******",this.listaProdsCerEmprising);
  console.log("Nueva lista Prods listaProdsNorma35 :******",this.listaProdsNorma35);

  console.log("lista de productos de esta empresa: ",{
    listaProdsCertificar: this.listaProdsCertificar,
    listaProdsMedir: this.listaProdsMedir,
    listaProdsPulse: this.listaProdsPulse,
    listaProdsFocus: this.listaProdsFocus,
    productosNorma35: this.productosContratadosInter.productosNorma35,
    productosDocumentador: this.productosContratadosInter.productosDocumentador,
    listaProductosCultureAuditV2: this.listaProductosCultureAuditV2,
    productosCultureAuditTR: this.productosContratadosInter.productosCultureAuditTR,
    listaProductosCultureAuditICCA: this.listaProductosCultureAuditICCA,
    listaAction: this.listaAction,
    listaProdsExpress: this.listaProdsExpress,
    listaProdsCerAmco: this.listaProdsCerAmco,
    listaProdsLeaderGo: this.listaProdsLeaderGo[0],
    listaProdsActionGo: this.listaProdsActionGo[0],
    listaProductosCultureBrief:this.listaProductosCultureBrief,
    listaProdsNorma35:this.listaProdsNorma35,
  });


}


private getYears() {
  this.odsService.getYearsArray().subscribe((response: any) => {
    console.log("años asignados::::::",response);
    this.years = response.anios;
  }, error => {
    console.log("error", error);
  });
}

private getYearsFocusAsignados() {
  this.odsService.getYearsArray().subscribe((response: any) => {
    console.log("años asignados::::::",response);
    this.years = response.anios;
console.log('this.years',this.years);
  this.focusAreaAños3();



  }, error => {
    console.log("error", error);
  });
}

focusAreaAños3(){
  let encuestaActiva:string;
  let modifUrlShort:boolean;
  let closeNotice:boolean;
  let selectNotice1:boolean;
  let selectNotice2:boolean;
  let moment = require('moment');
  let fechaActualC = moment().format('YYYY/MM/DD');
    let fechaActual:number;
    let fechaPulse:any[]=[];
    let anioNoSeleccionados:any[]=[];


this.listaProdsFocus[1].lista.forEach(anioAgregado => {
  console.log('anioAgregado',anioAgregado);
  if (anioAgregado.idProducto==43) {
  anioNoSeleccionados.push(anioAgregado);
  }
});

    anioNoSeleccionados.sort( (a,b) => {
      if(a.fechaCertificar > b.fechaCertificar){
        return 1;
      } else{
        return -1;
      }
    });
    console.log(anioNoSeleccionados);
let aniosDisponiblesFocus:any=[];
let fechaAsigandoFocus:any=[];

    anioNoSeleccionados.forEach((element,i) => {
      console.log('element',element);

      let datosPulsechek:any={};
      console.log(element.completoCertificar);

      let fechaLanzamiento= moment(element.fechaLanzamiento).format('YYYY/MM/DD');
      let fechaPortal= moment(fechaLanzamiento).isBefore(moment(fechaActualC));
      let modifUrlShort:boolean;
      let closeNotice:boolean;
      let selectNotice1:boolean;
      let selectNotice2:boolean;
      if(fechaPortal){
        console.log("econtro 1");
      this.btnPortalConteos=true;
    }else{
      this.btnPortalConteos=false;
    }
console.log('surveyProductId');

    if (element.surveyProductId) {
      console.log('entro surveyProductId');

      closeNotice=element.surveyProductId.config.closeNotice;
      selectNotice1=element.surveyProductId.config.selectNotice1;
      selectNotice2=element.surveyProductId.config.selectNotice2;
      modifUrlShort=element.surveyProductId.config.customSurveyUrl;
    }else{
      console.log('entro producto viejo');
      modifUrlShort=true;
      closeNotice=true;
      selectNotice1=true;
      selectNotice2=true;
    }
      if(fechaActual){
       datosPulsechek={
         completoCertificar: element.completoCertificar,
         fechaLanzamiento: element.fechaLanzamiento,
         fechaCertificar: element.fechaCertificar,
         idPlantilla: element.idPlantilla,
         idCertificar: element.idCertificar,
         idSurvey: element.idSurvey,
         tokenConfig: element.tokenConfig,
         btnPortalConteos:this.btnPortalConteos,
         encuestaActiva:element.openSurvey,
         numPulse:element.numPulse,
         modifUrlShort:modifUrlShort,
         closeNotice:closeNotice,
         selectNotice1:selectNotice1,
         selectNotice2:selectNotice2,
         nameSurvey:element.nameSurvey,

       }

        console.log(datosPulsechek);

        if(element.fechaCertificar == fechaActual){
          // fechaPulse.push(element);
          fechaPulse.push(datosPulsechek);
        }
        else {
          this.aniosPulsecheckSelect.push({fecha: fechaActual, datos: fechaPulse });
          fechaPulse=[];
          fechaActual=element.fechaCertificar;
          // fechaPulse.push(element);
          fechaPulse.push(datosPulsechek);
        }
      }
      else{
        datosPulsechek={
          completoCertificar: element.completoCertificar,
          fechaLanzamiento: element.fechaLanzamiento,
          fechaCertificar: element.fechaCertificar,
          idPlantilla: element.idPlantilla,
          idCertificar: element.idCertificar,
          idSurvey: element.idSurvey,
          tokenConfig: element.tokenConfig,
          btnPortalConteos:this.btnPortalConteos,
          numPulse:element.numPulse,
          encuestaActiva:element.openSurvey,
          modifUrlShort:modifUrlShort,
          closeNotice:closeNotice,
          selectNotice1:selectNotice1,
          selectNotice2:selectNotice2,
          nameSurvey:element.nameSurvey,

        }
        fechaActual=element.fechaCertificar;
        // fechaPulse.push(element);
        fechaPulse.push(datosPulsechek);
      }
      fechaPulse.sort( (a,b) => {
        if(a.numPulse > b.numPulse){ return 1; } else{ return -1; }
      });
      if(anioNoSeleccionados.length ==(i+1)){
        this.aniosPulsecheckSelect.push({fecha: element.fechaCertificar, datos: fechaPulse});
      }
    });
    console.log(this.aniosPulsecheckSelect);

this.aniosPulsecheckSelect.forEach(fechaAsigando => {
  fechaAsigandoFocus.push({fecha: fechaAsigando.fecha});
});
console.log('años asignados focus area ',fechaAsigandoFocus);

// fechaAsigandoFocus.forEach(fechaAsignada => {
//   if(this.years.findIndex(item => item.anio == fechaAsignada.fecha) == -1){
//    aniosDisponiblesFocus.push(fechaAsignada)
//   }
// });
let anios:any[];
this.years.forEach(fechaAsignada => {
  // if(fechaAsigandoFocus.findIndex(item => item.fecha == fechaAsignada.anio) == -1){
  //   console.log('entro adsfsnd');

   aniosDisponiblesFocus.push(fechaAsignada)
  // }
});
console.log('aniosDisponiblesFocus',aniosDisponiblesFocus);
anios=aniosDisponiblesFocus;
this.years=anios;
  }


getEstilos() {
  this.odsService.getestilos()
  .subscribe(response => {
    console.log(response);
    this.estilos = response['estilos'];
  }, error => {
    console.log("error", error);
  });
}

private getPlantillas(instituto) {
  let data = {
    idInstituto: instituto
  }
  this.odsService.getPlantillas(data)
  .subscribe(response => {
    if(response['message'] == 'Success'){
      this.plantillas = response['plantillasMostrar'];
    }

  }, error => {
    console.log("error", error);
  });
}

 getProjectManagerProductos(instituto) {

  this.odsService.getProjectManagerProduct(instituto)
  .subscribe((response:any) => {
console.log("response:",response);
this.projectManager=response.result;

  }, error => {
    console.log("error", error);
  });
}

// FUNCIÓN PARA NUEVAS EMAIL PLANTILLAS
checkResuls:boolean=false;
mensaje_typeProduct:any;

private getEmail_Plantillas(dato: number, activo: boolean) {
  if(activo){
    if(dato == 40 || dato == 41 || dato == 42 || dato == 43 || dato == 56 || dato == 57 || dato == 58 || dato == 69 || dato == 75){   //si es el certificar 3.0
      this.getTemplatesCertV3(dato);
    }
    else{   //si es otro producto
      if(dato == 34 || dato == 35 || dato == 36){
        this.selectEstilo_Results=null;
        console.log("Datos check");
        this.mensaje_typeProduct="MSJ_"+dato;
        this.checkResuls=true;
      }else{
        this.checkResuls=false;
      }
      if(dato== 18){
        this.linkLabel=true;
      }else{
        this.linkLabel=false;
      }
      this.reiniciaVariables(true);
      let data = {
        "productoId": dato,
        "instituto": this.enterpriseData['institutoEmpresa']
      }
      this.odsService.getEmail_Plantillas(data)
      .subscribe(response => {
        console.log(response);
        if(response['success'] == true){
          console.log("Perro plantilass");
          this.plantillas_email = response['paquetes'];
          this.plantillas_lan=response['plantillas'];
          console.log(this.plantillas_lan);

          //this.sendEmail_info(response['paquetes']);
        }


      }, error => {
        console.log("error", error);
      });
      //empieza validacion que cambia a año de ranking si es certificar o a año de aplicacion si es otro producto
      if(data.productoId == 1){
        this.anioranking=true;
      }
      else{
        this.anioranking=false;
      }
      //termina validacion

      if(dato == 1){
        this.flagPasos = true;
      }else{
        this.flagPasos = false;
      }
    }
  }

}

getTemplatesCertV3(dato:any){
  if (this.selectSector == 43) {
    this.getYearsFocusAsignados();
  }

  this.odsService.getTemplatesCertV3(this.instituto,dato).subscribe((respuesta:any) => {
    console.log("templatesV3:",respuesta);
    this.plantillas_email = respuesta.paquetes;
    let arregloTemplates: any[] = [];
    respuesta.surveyTemplates.forEach(template => {
      arregloTemplates.push({
        idPlantilla: template._id,
        instituto: template.broker.toString(),
        nombrePlantilla: template.name,
        oculto: false,
        tipo: "ESTANDAR"
      });
    });
    this.plantillas_lan = arregloTemplates;
  });
}

reiniciaVariables(cambio?:boolean){
  if(!cambio){
    this.selectPlantilla = null;
  }
  this.selectPlantillaEmail = null;
  this.selectYear = null;
  this.selectEstilo = null;
  this.surveyToken = null;
  this.typeOfResultsId = null;
  this.tableauVersion = null;
  this.selectCertificarAsociado="";
  this.statusProductoNorma35=false;
  this.productosDocumentadorNormaV3=[];
  this.productosDocumentadorNormaV1=[];
}

private sendEmail_info(array){
  //console.log("Arrays info");
  //console.log(array);

}

onChangeCheck(event,check){


  let flag = event['_selected'];

  switch(check) {
    case 1:
    this.flagNps = flag;
    //console.log('NPS '+this.flagNps);
    break;
    case 2:
    this.flagReactivos = flag;
    //console.log('flagReactivos '+this.flagReactivos);
    break;
    case 3:
    this.flagControl = flag;
    //console.log('flagControl '+this.flagControl);
    break;
    case 4:
    this.flagDemograficos = flag;
    //console.log('flagDemograficos '+this.flagDemograficos);
    break;
    case 5:
    this.flagAdicionales = flag;
    //console.log('flagAdicionales '+this.flagAdicionales);
    break;
    case 6:
    this.flagForall = flag;
    //console.log('flagForall '+this.flagForall);
    break;
    default:
    break;
  }
}

// public registerProduct(dato,fecha,plantilla,plantilla_email,estilo){
guardaActionLeaderGo(){
  let data:any;

  if (this.selectCertificarAsociado!="" || this.selectCertificarActionGo!="") {

    this.modalGuardado(2);
    let productoIdActualizar=this.selectSector == 53 ? this.selectCertificarAsociado: (this.selectSector == 54 ? this.selectCertificarActionGo.idCertificar : ''),
    data = {
        productoId: this.selectSector,
        fechaProducto: this.selectSector == 53 ? this.selectYear: (this.selectSector == 54 ? this.selectCertificarActionGo.fechaCertificar : ''),
        idPlantilla: null,
        idPaquete: null,
        cssId: null,
        asociadoId:this.selectSector == 53 ? this.selectCertificarAsociado: (this.selectSector == 54 ? this.selectCertificarActionGo.idCertificar : ''),
        nombreProducto:this.selectSector == 53 ? 'leader Go': (this.selectSector == 54 ? 'actionGo' : ''),
      };
      let datos={
        productId: this.selectSector,
      }
      console.log('datos',datos);
      console.log('data',data);

      this.odsService.createUsersActionGo(this.idEmpresa,productoIdActualizar,datos).subscribe( (dataInfo: any) => {
        console.log("createUsersActionGo",dataInfo);
        if (dataInfo.success) {
          this.registraProducto(data);
        }else{
          if (dataInfo.message=="NoUsersProcessed") {
            Swal.close();
            Swal.fire({
              title: this.translate.instant('MODALES.ERRORES.NO_PROCC_PROD_ASO'),
              icon: "error",

            });
            this.temporal = false;
          }else if(dataInfo.message=="NoUsersCreated"){
            this.registraProducto(data);
          }else{
            Swal.fire({
              title: this.translate.instant('MODALES.ERRORES.ERR_PROCC_PROD_ACT'),
              icon: "error",
            });
          }
        }


      });
  }else{
    this.temporal = false;
    this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.SIN_CERTIFICAR_ASOCIA'),this.translate.instant('ALERTS.OK'));
  }

}

validacionCaracEmail(email){
  let emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
  if (emailRegex.test(email.target.value)){
 console.log("La dirección de email " + email.target.value + " es correcta.");
      this.correctEmailUser=true;
} else {
  console.log("La dirección de email es incorrecta.");
  this.correctEmailUser=false;

  }
}

validarPassRegis(event:any){
  const head = document.getElementsByTagName('head')[0];
  let css='';
  // this.medirPassRegis=0;
  console.log(event.target.value);
  let regexPass = new RegExp("^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*([_]|[ -\/]|[:-\@]|[[-\`]|[{-\■])).{8,64}$");
  let regexMin = new RegExp("^(?=.*[a-z]).{1,64}$");
  let regexMay = new RegExp("^(?=.*[A-Z]).{1,64}$");
  let regexNum = new RegExp("^(?=.*[0-9]).{1,64}$");
  let regexCharEsp = new RegExp("[_]|[ -\/]|[:-\@]|[[-\`]|[{-\■]");
  if(event.target.value.length >=10 ){
    this.longitudPassRegis=true;
    this.regalasPassRegis[0].estatus=true;
  }else{
    this.longitudPassRegis=false;
    this.regalasPassRegis[0].estatus=false;
  }

  if(regexMin.test(event.target.value)){
    this.letraMinPassRegis=true;
    this.regalasPassRegis[1].estatus=true;
  }else{
    this.letraMinPassRegis=false;
    this.regalasPassRegis[1].estatus=false;
  }

  if(regexMay.test(event.target.value)){
    this.letraMayuPassRegis=true;
    this.regalasPassRegis[2].estatus=true;
  }else{
    this.letraMayuPassRegis=false;
    this.regalasPassRegis[2].estatus=false;
  }

  if(regexNum.test(event.target.value)){
    this.numePassRegis=true;
    this.regalasPassRegis[3].estatus=true;
  }else{
    this.numePassRegis=false;
    this.regalasPassRegis[3].estatus=false;
  }

  if(regexCharEsp.test(event.target.value)){
    this.caracterPassRegis=true;
    this.regalasPassRegis[4].estatus=true;
  }else{
    this.caracterPassRegis=false;
    this.regalasPassRegis[4].estatus=false;
  }


  console.log('regalasPass',this.regalasPassRegis);
  this.arregloReglasCumplidasRegis=[];

this.regalasPassRegis.forEach(estatus => {
if (estatus.estatus==true) {
 this.arregloReglasCumplidasRegis.push(estatus);
}
});

console.log('arregloReglasCumplidasRegis',this.arregloReglasCumplidasRegis);
if (this.arregloReglasCumplidasRegis.length==5) {
this.correctPassUser=true;
}else{
  this.correctPassUser=false;
}

}



public registerProduct(){
  console.log("Id plantilla "+this.selectPlantilla);
  this.temporal = true;
  let secciones = [];
  let data:any = {};
  console.log(this.selectSector);
  console.log(this.selectEstilo);
  if (this.selectSector==68) {
    if (this.nameUser!="") {
      if (this.totalColab!="") {
        if (this.emailUser!="") {
          if (this.correctEmailUser) {
            if (this.passUser!="") {
              if (this.correctPassUser) {
                this.modalGuardado(2);
                data = {
                  productoId: this.selectSector,
                  name:this.nameUser,
                  totalUsers:parseInt(this.totalColab),
                  email:this.emailUser,
                  password:this.passUser,
                  broker:this.instituto,
                  lang:this.translateSrv.currentLang,
                  empresaId:this.idEmpresa,
                  tipo: 8,

                };

                this.odsService.signUpUserSwift(data).subscribe((response:any) => {
                console.log('response signUpUserSwift',response);
                  if (response.success==true) {
                    this.odsService.saveProductSwift(this.idEmpresa).subscribe((response:any) => {
                      if (response.success==true) {
                        Swal.close();
                        this.openSuccessSnackBar(this.translate.instant('PERFILES.USUARIO.PRODUCT_REGISTEROK'),this.translate.instant('ALERTS.OK'));
                      }

                    }, error => {
                      //console.log("error", error);
                    })
                  }

                 // this.rankings = response.Seleccion;
                }, error => {
                  //console.log("error", error);
                })
                console.log('Datos Antes de enviar',data);

              }else{
                this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.WAR_INCO_PASS_US'),this.translate.instant('ALERTS.OK'));
                this.temporal = false;
              }

            }else{
                this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.WAR_ADD_PASS_US'),this.translate.instant('ALERTS.OK'));
              this.temporal = false;
            }
          }else{
            this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.WAR_INCO_EMA_US'),this.translate.instant('ALERTS.OK'));
            this.temporal = false;
          }
        }else{
          this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.WAR_ADD_EMA_US'),this.translate.instant('ALERTS.OK'));
          this.temporal = false;
        }
      }else{
        this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.WAR_ADD_TOT_US'),this.translate.instant('ALERTS.OK'));
        this.temporal = false;
      }

    }else{
      this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.WAR_ADD_NA_US'),this.translate.instant('ALERTS.OK'));
      this.temporal = false;
    }

    // this.registraProducto(data);
  }else{
    if(this.selectSector==18 ){
      this.selectPlantilla=1;
      this.selectPlantillaEmail="---";
      this.selectEstilo=1;

    }else if(this.selectSector==34 || this.selectSector==35 || this.selectSector==36){
      console.log("Valor de anio");
      console.log(this.selectEstilo_Results);
      this.selectPlantilla=1;
      this.selectPlantillaEmail="---";
      this.selectEstilo=1;
      this.selectYear=this.selectEstilo_Results;
    }
    switch(this.instituto) {
      case 1:
      //MEXICO
      if(this.selectSector==42){
        secciones = catSecciones.seccionesPulsecheck3;
      }else if(this.selectSector==40 || this.selectSector == 75){
        secciones = catSecciones.seccionesMX;
      }else if(this.selectSector==41){
        secciones = catSecciones.seccionesMedir3MX;
      }else if(this.selectSector==20){
        secciones = catSecciones.seccionesMX;
      }else if(this.selectSector==43){   ///caso focus area 3.0
        secciones = catSecciones.seccionesFocusArea3;
      }
      break;
      case 2:
      //CAYC

      if(this.selectSector==42){
        console.log("se asigno plantilla secciones pulsecheck 3.0 turquia ");

        secciones = catSecciones.seccionesPulsecheck3;
      }else{
        secciones = catSecciones.seccionesCAYC;
      }
      if(this.selectSector==43){   ///caso focus area 3.0
        secciones = catSecciones.seccionesFocusArea3;
      }
      if(this.selectSector==41){
        secciones = catSecciones.seccionesMedir3CAYC;
      }
      if(this.selectSector==69){
        secciones = catSecciones.seccionesCerPla;
      }
      break;
      case 3: case 22:
      //CHINA Y HK
      if(this.selectSector != 17 && this.selectSector != 8 && this.selectSector != 9  && this.selectSector != 37  && this.selectSector != 50  && this.selectSector != 51 && this.selectSector != 60 && this.selectSector != 54 && this.selectSector != 70){
        console.log("Id plantilla "+this.selectPlantilla);
        if(this.selectPlantilla.idPlantilla!="5e9605e0b473cb6d3ec67f3c"){ //CASO DE PLANTILLA RUMANO SIN CONTROL
          secciones = catSecciones.seccionesHK;
        }
        else{
          secciones = catSecciones.seccionesHKPlantillaRumano;
        }
      }
      if(this.selectSector==42){
        console.log("se asigno plantilla secciones pulsecheck 3.0 turquia ");

        secciones = catSecciones.seccionesPulsecheck3;
      }else if(this.selectSector==41){
        secciones = catSecciones.seccionesMedir3HK_CAYC;
      }

      if(this.selectSector==43){   ///caso focus area 3.0
        secciones = catSecciones.seccionesFocusArea3;
      }
      break;
      case 4:
      //SINGAPOUR
      if(this.selectSector==42){
        console.log("se asigno plantilla secciones pulsecheck 3.0 turquia ");

        secciones = catSecciones.seccionesPulsecheck3;
      }else{
        secciones = catSecciones.seccionesSGP;
      }
      if(this.selectSector==43){   ///caso focus area 3.0
        secciones = catSecciones.seccionesFocusArea3;
      }

      if(this.selectSector==41){
        secciones = catSecciones.seccionesMedir3MX;
      }
      break;
      case 5:
      //TURKEY
      if(this.selectSector != 17 && this.selectSector != 8 && this.selectSector != 9 && this.selectSector != 28 && this.selectSector != 29 && this.selectSector != 60 && this.selectSector != 54 && this.selectSector != 74){
        console.log("plantilla seleccionada: ",this.selectPlantilla.tipo);
        if(this.selectPlantilla.idPlantilla=="5f99fa14b473cb6d3e2d4012"){
          secciones = catSecciones.seccionesTRPlantilla;
        }else{
          if(this.selectPlantilla.tipo == 1){
            secciones = catSecciones.seccionesTR_1;
          }else if(this.selectPlantilla.tipo == 2){
            secciones = catSecciones.seccionesTR_2;
          }else if(this.selectPlantilla.tipo == 3){
            secciones = catSecciones.seccionesTR_3;
          }else{
            secciones = catSecciones.seccionesTR_3;
          }

        }
        console.log("selectPlantilla:",this.selectPlantilla," secciones:",secciones);

      }
      if(this.selectSector==42){
        console.log("se asigno plantilla secciones pulsecheck 3.0 turquia ");

        secciones = catSecciones.seccionesPulsecheck3Turquia;
      }
      if(this.selectSector==43){   ///caso focus area 3.0
        secciones = catSecciones.seccionesFocusArea3;
      }
      if(this.selectSector==41){
        secciones = catSecciones.seccionesMedir3TR;
      }
      break;
      case 6:
      //FILIPINAS
      if(this.selectSector==42){
        console.log("se asigno plantilla secciones pulsecheck 3.0 turquia ");

        secciones = catSecciones.seccionesPulsecheck3;
      }else{
        secciones = catSecciones.seccionesFL;
      }
      if(this.selectSector==43){   ///caso focus area 3.0
        secciones = catSecciones.seccionesFocusArea3;
      }

      if(this.selectSector==41){
        secciones = catSecciones.seccionesMedir3HK_CAYC;
      }
      break;
      case 8:
      //IZZI
      if(this.selectSector==42){
        console.log("se asigno plantilla secciones pulsecheck 3.0 turquia ");

        secciones = catSecciones.seccionesPulsecheck3;
      }else{
        secciones = catSecciones.seccionesIzzi;
      }
      if(this.selectSector==43){   ///caso focus area 3.0
        secciones = catSecciones.seccionesFocusArea3;
      }

      if(this.selectSector==41){
        secciones = catSecciones.seccionesMedir3MX;
      }
      break;

      case 11:
      //BRASIL
      if(this.selectSector==42){
        console.log("se asigno plantilla secciones pulsecheck 3.0 turquia ");

        secciones = catSecciones.seccionesPulsecheck3;
      }else{
        secciones = catSecciones.seccionesBrasil;
      }
      if(this.selectSector==43){   ///caso focus area 3.0
        secciones = catSecciones.seccionesFocusArea3;
      }

      if(this.selectSector==41){
        secciones = catSecciones.seccionesMedir3MX;
      }
      break;
      case 14:
      //GCTI
      if(this.selectSector==42){
        console.log("se asigno plantilla secciones pulsecheck 3.0 turquia ");

        secciones = catSecciones.seccionesPulsecheck3;
      }else{
        secciones = catSecciones.seccionesGCTI;
      }
      if(this.selectSector==43){   ///caso focus area 3.0
        secciones = catSecciones.seccionesFocusArea3;
      }
      if(this.selectSector==41){
        secciones = catSecciones.seccionesMedir3MX;
      }
      break;

      case 15:
      //ESPAÑA
      if(this.selectSector==42){
        console.log("se asigno plantilla secciones pulsecheck 3.0 turquia ");

        secciones = catSecciones.seccionesPulsecheck3;
      }else{
        secciones = catSecciones.seccionesSpain;
      }
      if(this.selectSector==43){   ///caso focus area 3.0
        secciones = catSecciones.seccionesFocusArea3;
      }
      if(this.selectSector==41){
        secciones = catSecciones.seccionesMedir3MX;
      }
      break;
      case 18:
      //AMCO
      if(this.selectSector == 41){
        secciones = catSecciones.seccionesMedir3MX;
      }
      break;
      case 19:
      console.log("selectSector",this.selectSector);
      console.log("selectPlantilla",this.selectPlantilla);
      //AMCO
      if(this.selectSector == 41){
        const prodsGCTISinNPSControl = ['63f6e6ad7886c3442a913c84', '659f1eb45d6fcd890b549d8f', '65b145b28a58ac6fc7aed72c'];
        if (prodsGCTISinNPSControl.includes(this.selectPlantilla.idPlantilla)) {
          secciones = catSecciones.seccionesGCTI_2023_ESP_ING_V1;
        }else{
          secciones = catSecciones.seccionesMedir3MX;
        }
      }
      break;
    }


    if(this.selectPlantilla != undefined || this.isCA || this.selectSector == 17 || this.selectSector == 6 || this.selectSector == 43 || this.selectSector == 53|| this.selectSector == 54 || this.selectSector == 60 || this.selectSector == 70){
      //si hay this.selectPlantilla o es CA o es producto resultados
      if(this.selectSector > 0){
        if (this.selectSector ==53) {
          console.log('Hace la Validacion para el producto Leader go V1');
          if (this.instituto==1||this.instituto==2) {
            if (!this.typeOfResultsId) {
              this.temporal = false;
              this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.SINIDTYPERESULT'),this.translate.instant('ALERTS.OK'));

            }else{
              console.log('Mando a llamar la funcion de guardar liderGo  ');
              this.guardaActionLeaderGo();
            }
          }else{
            console.log('Mando a llamar la funcion de guardar liderGo  ');
            this.guardaActionLeaderGo();
          }

        }else if (this.selectSector ==54) {
          console.log('Mando a llamar la funcion de guardar ActionGo, Hace la Validacion para el producto ActionGo ');
          if (this.instituto==1||this.instituto==2) {
            if (!this.typeOfResultsId) {
              this.temporal = false;
              this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.SINIDTYPERESULT'),this.translate.instant('ALERTS.OK'));

            }else{
              this.guardaActionLeaderGo();
            }
          }else{
            this.guardaActionLeaderGo();
          }

        }else{
          console.log("entro como producto diferente");

          if(this.selectYear > 0){
            if(this.selectEstilo == 0 || this.selectEstilo == 1 || this.selectEstilo == 4 || this.isCA || this.selectSector == 17 || this.selectSector == 43 || this.selectSector == 53 || this.selectSector == 54 || this.selectSector == 60 || this.selectSector == 70){
              let data;
              if(this.selectSector == 1 || this.selectSector == 20 || this.selectSector == 27 || this.selectSector == 40 || this.selectSector == 41 || this.selectSector == 42 || this.selectSector == 43 || this.selectSector==69 || this.selectSector == 75){  // producto certificar o certificar v2
                let nombreProduco:string='';
                switch (this.selectSector ) {
                  case 1:
                  nombreProduco='Certify'
                  break;
                  case 20:
                  nombreProduco='Certify'
                  break;
                  case 27:
                  nombreProduco='Certify'
                  break;
                  case 40:
                  nombreProduco='Certify3'
                  break;
                  case 41:
                  nombreProduco='Measure3'
                  break;
                  case 42:
                  nombreProduco='Pulse3'
                  break;
                  case 43:
                  nombreProduco='Focus 1'

                  break;
                  case 69:
                  nombreProduco='Certify_Plat'

                  break;
                  case 75:
                  nombreProduco='GPTW+GCTI'
                  break;

                  default:
                  break;
                }
                if (this.selectSector==43) {
                  console.log('datos al agregar focus Area');
                  data = {
                    productoId: this.selectSector,
                    fechaProducto: this.selectYear,
                    // idPlantilla: this.selectPlantilla.idPlantilla,
                    // idPaquete: this.selectPlantillaEmail,
                    // cssId: this.selectEstilo,
                    secciones : secciones,
                    // nombrePlantilla:this.selectPlantilla.nombrePlantilla,
                    nombreProducto:nombreProduco,
                  };
                }else{
                  console.log('datos al agregar producto Normal');
                  data = {
                    productoId: this.selectSector,
                    fechaProducto: this.selectYear,
                    idPlantilla: this.selectPlantilla.idPlantilla,
                    idPaquete: this.selectPlantillaEmail,
                    cssId: this.selectEstilo,
                    secciones : secciones,
                    nombrePlantilla:this.selectPlantilla.nombrePlantilla,
                    nombreProducto:nombreProduco,
                  };
                  if(this.selectSector == 40 || this.selectSector == 75){
                    data.añoRanking = this.anioRankingCert3;
                    switch (this.instituto) {
                      case 8: data.rankingName = "IZZI"; break;
                      case 14: data.rankingName = "GCTI"; break;
                      case 18: data.rankingName = "AMCO"; break;
                      default: data.rankingName = "GPTW";
                    }
                    data.rankingType = this.tipoRankingCert3;
                    data.rankingEnabled = this.rankEnabledCert3;
                    data.rankingRange = this.rangoRankingCert3;
                  }
                  data.oportunity_id = this.oportunityId;
                  data.oportunity_name = this.oportunityName;
                  data.typeOfResults_id = this.typeOfResultsId;
                  data.project_manager_id = this.proyectManager;
                  // data.email_promanager = this.proyectManagerEmail;
                }
                console.log('data',data);

                if(this.selectSector == 1) data.tipo = 1;
                if(this.selectSector == 20) data.tipo = 2;
                if(this.selectSector == 27) data.tipo = 3;
                if(this.selectSector == 40) data.tipo = 4;
                if(this.selectSector == 69) data.tipo = 9;
                if(this.selectSector == 75) data.tipo = 11;
              }else if (this.selectSector == 56 || this.selectSector == 57 || this.selectSector == 58) {
                let nombreProducto:string='';
                let tipoProducto:number=0;
                let secciones:any;
                switch (this.selectSector) {
                  case 56:
                  nombreProducto='Certify_Amco';
                  tipoProducto=5;
                  secciones= catSecciones.seccionesCerAmco;
                  break;
                  case 57:
                  nombreProducto='Certify_Trab';
                  tipoProducto=6;
                  secciones= catSecciones.seccionesCerTrabajoDigno;
                  break;
                  case 58:
                  nombreProducto='Certify_Pri';
                  tipoProducto=7;
                  secciones= catSecciones.seccionesCerPrimerTrabajo;
                  break;


                  default:
                  break;
                }
                data = {
                  productoId: this.selectSector,
                  fechaProducto: this.selectYear,
                  idPlantilla: this.selectPlantilla.idPlantilla,
                  idPaquete: this.selectPlantillaEmail,
                  cssId: this.selectEstilo,
                  secciones : secciones,
                  nombrePlantilla:this.selectPlantilla.nombrePlantilla,
                  nombreProducto:nombreProducto,
                  añoRanking: this.anioRankingCert3,
                  rankingType:this.tipoRankingCert3,
                  oportunity_id:this.oportunityId,
                  oportunity_Name:this.oportunityName,
                  typeOfResults_id:this.typeOfResultsId,
                  project_manager_id:this.proyectManager,
                  // email_promanager:this.proyectManagerEmail,
                  tipo: tipoProducto,
                };

                console.log("Datos a enviar amco",data);
              }else if(this.selectSector == 11 || this.selectSector == 12 || this.selectSector == 13 || this.selectSector == 14 || this.selectSector == 15 || this.selectSector == 16 ){  // producto medir mejorado
                console.log("Parte de medir");
                let nombreProducto:string='';
                switch (this.selectSector ) {
                  case 11:
                  nombreProducto='Measure 1'
                  break;
                  case 12:
                  nombreProducto='Measure 2'
                  break;
                  case 13:
                  nombreProducto='Measure 3'
                  break;
                  case 14:
                  nombreProducto='Measure 4'
                  break;
                  case 15:
                  nombreProducto='Measure 5'
                  break;
                  case 16:
                  nombreProducto='Measure 6'

                  break;

                  default:
                  break;
                }
                if(this.selectSector!= 16){
                  data = {
                    productoId: this.selectSector,
                    fechaProducto: this.selectYear,
                    idPlantilla: this.selectPlantilla.idPlantilla,
                    idPaquete: this.selectPlantillaEmail,
                    cssId: this.selectEstilo,
                    secciones : catSecciones.seccionesMedir_1,
                    tipo: (this.selectSector-10),
                    nombreProducto:nombreProducto,
                  };


                  console.log('Aqui se asigna la plantilla para medir mejorado');

                }else{
                  data = {
                    productoId: this.selectSector,
                    fechaProducto: this.selectYear,
                    idPlantilla: this.selectPlantilla.idPlantilla,
                    idPaquete: this.selectPlantillaEmail,
                    cssId: this.selectEstilo,
                    secciones : catSecciones.seccionesMedir_Generico,
                    tipo: (this.selectSector-10),
                    nombreProducto:nombreProducto,
                  };
                }
                console.log("Data medir generico");
                console.log(data);
              }
              else if(this.selectSector == 17){  // producto resultados
                if (this.validarNivelUser!=3) {
                  console.log("Usuario diferente a itbm");

                  if(this.instituto == 1){
                    this.tableauVersion="3.2";
                    this.surveyToken=" ";
                  }
                  else if(this.instituto == 5){
                    this.tableauVersion="3.3";
                    this.surveyToken=" ";
                  }else{
                    this.tableauVersion="3.1";
                    this.surveyToken=" ";
                  }
                }else{

                }
                let prodCertCoincidente = this.productosContratadosInter.productosCertificar.find(item => item.fechaCertificar == this.selectYear);
                if(prodCertCoincidente != undefined){
                  this.surveyToken = prodCertCoincidente.idSurvey != undefined ? prodCertCoincidente.tokenConfig.toString() : this.surveyToken;
                }

                console.log("este es elsurvey toke ::::::::::::::::::",this.surveyToken,);

                data = {
                  productoId: this.selectSector,
                  fechaProducto: this.selectYear,
                  surveyToken: this.surveyToken,
                  version: this.tableauVersion
                };

              }else if(this.selectSector == 70){
                data = {
                  productoId: this.selectSector,
                  fechaProducto: this.selectYear,
                  tipo: 10,
                };
                // this.registraProducto(data);
              }else if(this.selectSector == 60){
                data = {
                  productoId: this.selectSector,
                  fechaProducto: this.selectYear,
                  version: this.tableauVersion
                };
                // this.registraProducto(data);
              }
              else if(this.isCA){
                data = {
                  productoId: this.selectSector,
                  fechaProducto: this.selectYear,
                  idPlantilla: null,
                  idPaquete: null,
                  cssId: null,
                  asociadoId:this.selectCertificarAsociado
                };
              }else if (this.selectSector == 6) {
                console.log("Preducto Focus area ");
                data = {
                  productoId: this.selectSector,
                  fechaProducto: this.selectYear,
                  idPlantilla:'5e166105d06d595eb04dca00',
                  idPaquete: this.selectPlantillaEmail,
                  cssId: this.selectEstilo
                };
              }
              // else if (this.selectSector == 53) {
                //   data = {
                  //     productoId: this.selectSector,
                  //     fechaProducto: this.selectYear,
                  //     idPlantilla: null,
                  //     idPaquete: null,
                  //     cssId: null,
                  //     asociadoId:this.selectCertificarAsociado,
                  //   };
                  //   console.log('datos del lider Go',data);
                  // }
                  else{
                    data = {
                      productoId: this.selectSector,
                      fechaProducto: this.selectYear,
                      idPlantilla: this.selectPlantilla.idPlantilla,
                      idPaquete: this.selectPlantillaEmail,
                      cssId: this.selectEstilo
                    };
                  }

                  if(this.selectSector == 17){
                    if(this.surveyToken && this.tableauVersion){
                      console.log("entro resultados ",data);

                      //BUSCA SI HAY UN PRODUCTO CERTIFICAR EXISTENTE CON EL MISMO AÑO, SI LO HAY NO SE GUARDA EL RESULTADOS
                      let anioCoinciEncontrado = false;
                      this.listaProdsCertificar.forEach(tipoCert => {
                        let anioCoincidente = tipoCert.lista.find(item => item.fechaCertificar == data.fechaProducto);
                        anioCoinciEncontrado = anioCoincidente != undefined ? true : anioCoinciEncontrado;
                      });
                      if(!anioCoinciEncontrado){
                        console.log('Hace la Validacion para el producto Norma V1');
                        if (this.instituto==1||this.instituto==2) {
                          if (!this.typeOfResultsId) {
                            this.temporal = false;
                            this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.SINIDTYPERESULT'),this.translate.instant('ALERTS.OK'));

                          }else{
                            this.registraProducto(data);
                          }
                        }else{

                          this.registraProducto(data);
                        }
                        // this.registraProducto(data);
                      } else{
                        this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.MISMOANIOCERTIFICAR'),this.translate.instant('ALERTS.OK'));
                        this.temporal = false;
                      }
                    }
                    else{
                      if(!this.surveyToken){
                        this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.SIN_SURVEYTOKEN'),this.translate.instant('ALERTS.OK'));
                        this.temporal = false;
                      }
                      if(!this.tableauVersion){
                        this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.SIN_TABLEAUVER'),this.translate.instant('ALERTS.OK'));
                        this.temporal = false;
                      }
                    }
                  }if(this.selectSector == 70){
                    console.log("entro resultados ",data);

                    // if(!anioCoinciEncontrado){
                      //   console.log('Hace la Validacion para el producto Norma V1');
                      //   if (this.instituto==1||this.instituto==2) {
                        //     if (!this.typeOfResultsId) {
                          //       this.temporal = false;
                          //       this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.SINIDTYPERESULT'),this.translate.instant('ALERTS.OK'));
                          //
                          //     }else{
                            //       this.registraProducto(data);
                            //     }
                            //   }else{

                              this.registraProducto(data);
                              // }
                              // this.registraProducto(data);
                              // } else{
                                //   this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.MISMOANIOCERTIFICAR'),this.translate.instant('ALERTS.OK'));
                                //   this.temporal = false;
                                // }
                              }
                              else if (this.selectSector == 60) {
                                if (this.instituto==1||this.instituto==2) {
                                  if (!this.typeOfResultsId) {
                                    this.temporal = false;
                                    this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.SINIDTYPERESULT'),this.translate.instant('ALERTS.OK'));

                                  }else{
                                    this.registraProducto(data);
                                  }
                                }else{

                                  this.registraProducto(data);
                                }
                                // this.registraProducto(data);
                              }else if(this.selectSector == 18){ //REsultados
                                let url01=$("#url").val();
                                data = {
                                  productoId: this.selectSector,
                                  fechaProducto: this.selectYear,
                                  link : url01
                                };
                                if(url01.length){
                                  this.registraProducto(data);
                                }else{
                                  let texto = 'ALERTS.FIELD';
                                  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                                  console.log("Entro porque hay más de uno en norma");
                                  Swal.fire({
                                    title: texto,
                                    icon: "error",
                                    confirmButtonColor: '#e40601'
                                  });
                                }
                              }else if(this.selectSector == 34 || this.selectSector == 35 || this.selectSector == 36 ){
                                console.log("Registrar productos versión 3");
                                /*switch (this.selectSector){
                                  case 34:
                                  console.log(this.productosContratadosInter);
                                  if(this.productosContratadosInter.productosCertificar.length > 0){
                                    console.log("Se puede registrar");
                                    data = {
                                      productoId: this.selectSector,
                                      fechaProducto: this.selectYear,
                                      tipo: 1,

                                    }

                                    let prodCertCoincidente = this.productosContratadosInter.productosCertificar.find(item => item.fechaCertificar == this.selectYear);
                                    if(prodCertCoincidente != undefined){
                                      this.surveyToken = prodCertCoincidente.idSurvey != undefined ? prodCertCoincidente.tokenConfig.toString() : this.surveyToken;
                                    }

                                    break;
                                  }*/



                                }else{
                                  console.log("Posiblemente sea este");
                                  console.log(this.statusProductoNorma35);
                                  console.log(data);
                                  if(this.statusProductoNorma35 &&  this.selectSector == 19){
                                    let texto = 'ALERTS.LABEL01';
                                    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                                    Swal.fire({
                                      title: texto,
                                      icon: "error",
                                      confirmButtonColor: '#e40601'
                                    });
                                    //this.statusProductoNorma35=false;
                                    this.temporal=false;

                                  }else if(this.statusProductoNorma35 && this.selectSector==3){
                                    data = {
                                      productoId: this.selectSector,
                                      fechaProducto: this.selectYear,
                                      idPlantilla: this.selectPlantilla.idPlantilla,
                                      idPaquete: this.selectPlantillaEmail,
                                      cssId: this.selectEstilo,
                                      tipo: 1
                                    };
                                    console.log("Data ");
                                    let texto = 'ALERTS.LABEL01';
                                    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                                    Swal.fire({
                                      title: texto,
                                      icon: "error",
                                      confirmButtonColor: '#e40601'
                                    });
                                    this.statusProductoNorma35=false;
                                    this.temporal=false;


                                  }else if(this.statusProductoNorma35 && this.selectSector==39){
                                    data = {
                                      productoId: this.selectSector,
                                      fechaProducto: this.selectYear,
                                      idPlantilla: this.selectPlantilla.idPlantilla,
                                      idPaquete: this.selectPlantillaEmail,
                                      cssId: this.selectEstilo,
                                      tipo: 3
                                    };
                                    console.log("Data ");
                                    let texto = 'ALERTS.LABEL01';
                                    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                                    Swal.fire({
                                      title: texto,
                                      icon: "error",
                                      confirmButtonColor: '#e40601'
                                    });
                                    this.statusProductoNorma35=false;
                                    this.temporal=false;


                                  }else if(this.statusProductoNorma35 && this.selectSector==63){
                                    data = {
                                      productoId: this.selectSector,
                                      fechaProducto: this.selectYear,
                                      idPlantilla: this.selectPlantilla.idPlantilla,
                                      idPaquete: this.selectPlantillaEmail,
                                      cssId: this.selectEstilo,
                                      tipo: 4
                                    };
                                    console.log("Data ");
                                    let texto = 'ALERTS.LABEL01';
                                    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                                    Swal.fire({
                                      title: texto,
                                      icon: "error",
                                      confirmButtonColor: '#e40601'
                                    });
                                    this.statusProductoNorma35=false;
                                    this.temporal=false;
                                  }
                                  else if(this.selectSector == 19){
                                    data = {
                                      productoId: this.selectSector,
                                      fechaProducto: this.selectYear,
                                      idPlantilla: this.selectPlantilla.idPlantilla,
                                      idPaquete: this.selectPlantillaEmail,
                                      cssId: this.selectEstilo,
                                      tipo: 2
                                    };

                                    //console.log("Data producto Better");
                                    //console.log(data);
                                    this.registraProducto(data);
                                  }else if(this.selectSector == 3){
                                    data = {
                                      productoId: this.selectSector,
                                      fechaProducto: this.selectYear,
                                      idPlantilla: this.selectPlantilla.idPlantilla,
                                      idPaquete: this.selectPlantillaEmail,
                                      cssId: this.selectEstilo,
                                      tipo: 1
                                    };
                                    //console.log("Data producto Good");
                                    //console.log(data);
                                    console.log('Hace la Validacion para el producto Norma V1');
                                    if (this.instituto==1||this.instituto==2) {
                                      if (!this.typeOfResultsId) {
                                        this.temporal = false;
                                        this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.SINIDTYPERESULT'),this.translate.instant('ALERTS.OK'));

                                      }else{
                                        this.registraProducto(data);
                                      }
                                    }else{

                                      this.registraProducto(data);
                                    }
                                    // this.registraProducto(data);

                                  }else if(this.selectSector == 39){
                                    data = {
                                      productoId: this.selectSector,
                                      fechaProducto: this.selectYear,
                                      idPlantilla: this.selectPlantilla.idPlantilla,
                                      idPaquete: this.selectPlantillaEmail,
                                      cssId: this.selectEstilo,
                                      tipo: 3
                                    };
                                    //console.log("Data producto Good");
                                    //console.log(data);
                                    this.registraProducto(data);

                                  }else if(this.selectSector == 63){
                                    data = {
                                      productoId: this.selectSector,
                                      fechaProducto: this.selectYear,
                                      idPlantilla: this.selectPlantilla.idPlantilla,
                                      idPaquete: this.selectPlantillaEmail,
                                      cssId: this.selectEstilo,
                                      tipo: 4
                                    };
                                    this.registraProducto(data);
                                  }
                                  else if (this.selectSector == 28){
                                    console.log("audit 2.0");
                                    data = {
                                      productoId: this.selectSector,
                                      fechaProducto: this.selectYear,
                                      idPlantilla: null,
                                      idPaquete: null,
                                      cssId: this.selectEstilo,
                                      tipo: 2,
                                    };
                                    this.registraProducto(data);
                                  }else if (this.selectSector == 29){
                                    console.log("audit 3.0");
                                    data = {
                                      productoId: this.selectSector,
                                      fechaProducto: this.selectYear,
                                      idPlantilla: null,
                                      idPaquete: null,
                                      cssId: this.selectEstilo,
                                      tipo: 3,
                                      asociadoId:this.selectCertificarAsociado
                                    };
                                    this.registraProducto(data);
                                  }else if (this.selectSector == 74){
                                    console.log("audit 3.0");
                                    data = {
                                      productoId: this.selectSector,
                                      fechaProducto: this.selectYear,
                                      idPlantilla: null,
                                      idPaquete: null,
                                      cssId: this.selectEstilo,
                                      tipo: 29,
                                      asociadoId:this.selectCertificarAsociado
                                    };
                                    this.registraProducto(data);
                                  }
                                  else if (this.selectSector == 30){
                                    console.log("Costa Rica audit");
                                    data = {
                                      productoId: this.selectSector,
                                      fechaProducto: this.selectYear,
                                      idPlantilla: null,
                                      idPaquete: null,
                                      cssId: this.selectEstilo,
                                      tipo: 4,
                                      asociadoId:this.selectCertificarAsociado
                                    };
                                    this.registraProducto(data);
                                  }else if (this.selectSector == 31){
                                    console.log("GoFlow audit");
                                    data = {
                                      productoId: this.selectSector,
                                      fechaProducto: this.selectYear,
                                      idPlantilla: null,
                                      idPaquete: null,
                                      cssId: this.selectEstilo,
                                      tipo: 5,
                                      asociadoId:this.selectCertificarAsociado
                                    };
                                    console.log("Data producto");
                                    console.log(data);
                                    this.registraProducto(data);
                                  }else if (this.selectSector == 32){
                                    console.log("Panamá audit");
                                    data = {
                                      productoId: this.selectSector,
                                      fechaProducto: this.selectYear,
                                      idPlantilla: null,
                                      idPaquete: null,
                                      cssId: this.selectEstilo,
                                      tipo: 6,
                                      asociadoId:this.selectCertificarAsociado
                                    };
                                    console.log("Data producto");
                                    console.log(data);
                                    this.registraProducto(data);

                                  }else if (this.selectSector == 33){
                                    console.log("Strategic Partners audit");
                                    data = {
                                      productoId: this.selectSector,
                                      fechaProducto: this.selectYear,
                                      idPlantilla: null,
                                      idPaquete: null,
                                      cssId: this.selectEstilo,
                                      tipo: 7,
                                      asociadoId:this.selectCertificarAsociado
                                    };
                                    console.log("Data producto");
                                    console.log(data);
                                    this.registraProducto(data);
                                  }else if (this.selectSector == 37){
                                    console.log("Culture audir sp");
                                    data = {
                                      productoId: this.selectSector,
                                      fechaProducto: this.selectYear,
                                      idPlantilla: null,
                                      idPaquete: null,
                                      cssId: this.selectEstilo,
                                      tipo: 8,
                                      asociadoId:this.selectCertificarAsociado
                                    };
                                    console.log("Data producto");
                                    console.log(data);
                                    this.registraProducto(data);
                                  }else if (this.selectSector == 38){
                                    console.log("Culture audit action plan");
                                    data = {
                                      productoId: this.selectSector,
                                      fechaProducto: this.selectYear,
                                      idPlantilla: null,
                                      idPaquete: null,
                                      cssId: this.selectEstilo,
                                      tipo: 9,
                                      asociadoId:this.selectCertificarAsociado
                                    };
                                    console.log("Data producto");
                                    console.log(data);
                                    this.registraProducto(data);
                                  }
                                  else if([44,45,46,48,49,50,51,55,59,61,62,64,65,66,67,71,72,73,76,77,78,80].includes(this.selectSector)){
                                    data = {
                                      productoId: this.selectSector,
                                      fechaProducto: this.selectYear,
                                      idPlantilla: null,
                                      idPaquete: null,
                                      cssId: this.selectEstilo,
                                      asociadoId:this.selectCertificarAsociado
                                    };
                                    switch (this.selectSector) {
                                      case 44: data.tipo = 10; break;
                                      case 45: data.tipo = 11; break;
                                      case 46: data.tipo = 12; break;
                                      case 48: data.tipo = 14; break;
                                      case 49: data.tipo = 15; break;
                                      case 50: data.tipo = 16; break;
                                      case 51: data.tipo = 17; break;
                                      case 55: data.tipo = 18; break;
                                      case 59: data.tipo = 19; break;
                                      case 61: data.tipo = 20; break;
                                      case 62: data.tipo = 21; break;
                                      case 64: data.tipo = 22; break;
                                      case 65: data.tipo = 23; break;
                                      case 66: data.tipo = 24; break;
                                      case 67: data.tipo = 25; break;
                                      case 71: data.tipo = 26; break;
                                      case 72: data.tipo = 27; break;
                                      case 73: data.tipo = 28; break;
                                      case 76: data.tipo = 30; break;
                                      case 77: data.tipo = 31; break;
                                      case 78: data.tipo = 32; break;
                                      case 80: data.tipo = 34; break;
                                    }
                                    console.log("data CA:",data);

                                    this.registraProducto(data);
                                  }
                                  else{ //   certificar
                                    if(this.selectSector == 40 || this.selectSector == 75){  //validacion de año ranking para certificar 3
                                      if(!this.anioRankingCert3){
                                        this.temporal = false;
                                        this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.SINRANKING'),this.translate.instant('ALERTS.OK'));
                                      } else{
                                        if(!this.tipoRankingCert3){
                                          this.temporal = false;
                                          this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.SINTIPORANK'),this.translate.instant('ALERTS.OK'));
                                        } else{
                                          if(this.instituto == 1){
                                            if(!this.oportunityId){
                                              this.temporal = false;
                                              this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.SINIDOPORTUNITY'),this.translate.instant('ALERTS.OK'));
                                            }else if (!this.oportunityName) {
                                              this.temporal = false;
                                              this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.SINNAMEOPORTUNITY'),this.translate.instant('ALERTS.OK'));
                                            }else if(!this.typeOfResultsId){
                                              this.temporal = false;
                                              this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.SINIDTYPERESULT'),this.translate.instant('ALERTS.OK'));

                                            } else{
                                              // if(!this.proyectManager){
                                                //   this.temporal = false;
                                                //   this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.SINPROYECTMANAGER'),this.translate.instant('ALERTS.OK'));
                                                // } else{
                                                  //   if(!this.proyectManagerEmail){
                                                    //     this.temporal = false;
                                                    //     this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.SINCORREOPM'),this.translate.instant('ALERTS.OK'));
                                                    //   } else{
                                                      //     if(!this.regexEmail.test(this.proyectManagerEmail)){
                                                        //       this.temporal = false;
                                                        //       this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.EMAILNOVALIDO'),this.translate.instant('ALERTS.OK'));
                                                        //      } else{
                                                          //    this.registraProducto(data);
                                                          //     }
                                                          //    }
                                                          // }
                                                          this.seleccionarInfraDedica(this.selectSector,data);
                                                          // this.registraProducto(data);
                                                        }
                                                      }else if (this.instituto == 2) {
                                                        if (!this.typeOfResultsId) {
                                                          this.temporal = false;
                                                          this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.SINIDTYPERESULT'),this.translate.instant('ALERTS.OK'));

                                                        }else{
                                                          this.seleccionarInfraDedica(this.selectSector,data);
                                                          // this.registraProducto(data);
                                                        }
                                                      } else{
                                                        this.seleccionarInfraDedica(this.selectSector,data);
                                                        // this.registraProducto(data);
                                                      }
                                                    }
                                                  }
                                                }
                                                else{
                                                  console.log('guarda cualquier otro producto que no es certficar', this.selectSector);
                                                  if (this.instituto==1||this.instituto==2) {
                                                    if (!this.typeOfResultsId) {
                                                      this.temporal = false;
                                                      this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.SINIDTYPERESULT'),this.translate.instant('ALERTS.OK'));

                                                    }else{
                                                    this.seleccionarInfraDedica(this.selectSector,data);
                                                      // this.registraProducto(data);
                                                    }
                                                  }else{
                                                    this.seleccionarInfraDedica(this.selectSector,data);
                                                    // this.registraProducto(data);
                                                  }
                                                }
                                              }
                                              //
                                            }
                                          }else{
                                            this.openErrorSnackBar('Please select a CSSID','OK');
                                            this.temporal = false;
                                            //this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.MSJ_SELECTYEAR'),this.translate.instant('ALERTS.OK'));
                                          }
                                        }else{
                                          //this.openErrorSnackBar('Please select a year','OK');
                                          if(this.checkResuls){
                                            console.log("Mensaje "+this.mensaje_typeProduct);
                                            let mensaje=''+'PERFILES.USUARIO.'+this.mensaje_typeProduct;
                                            this.openErrorSnackBar(this.translate.instant(mensaje),this.translate.instant('ALERTS.OK'));
                                            this.temporal = false;
                                          }else{
                                            this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.MSJ_SELECTYEAR'),this.translate.instant('ALERTS.OK'));
                                            this.temporal = false;
                                          }

                                        }

                                      }



                                    }else{
                                      //this.openErrorSnackBar('Please select a product','OK');
                                      this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.MSJ_SELECTPRODUCT'),this.translate.instant('ALERTS.OK'));
                                      this.temporal = false;
                                    }
                                  }else{
                                    //this.openErrorSnackBar('Please select a template','OK');
                                    this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.MSJ_SELECTTEMPLETE'),this.translate.instant('ALERTS.OK'));
                                    this.temporal = false;
                                  }

  }
}

  seleccionarInfraDedica(productoId:any,data:any){
    switch (productoId) {
      case 40: case 41:
      if (this.validarNivelUser==3) {
        this.modalInfraEstructura(data);
      }else{
        this.registraProducto(data);
      }
        break;
      default:
      this.registraProducto(data);
        break;
    }
  }

validacion_anio:boolean;
registraProducto(data:any){
  console.log("datos antes de guardar::",data);
  console.log("::::::Se guardar el producto de manera normal::::");
  this.tableauVersion=null;
  this.surveyToken=null;
  this.validacionanio(data);
  this.linkLabel=false;
  this.validacion_anio=this.validacionanio(data);
  console.log("Validación anio");
  console.log(this.validacion_anio);
  if(this.validacion_anio){
    if (this.selectSector !=54) {
      this.modalGuardado(2);
    }
    // Swal.fire({
    //   title: this.translate.instant('PERFILES.USUARIO.GUARDANDOPRODUCTO'),
    //   allowOutsideClick: false,
    //   didOpen: () => {
    //     Swal.showLoading()
    //   }
    // });
    this.odsService.matchCompanyProduct(this.idEmpresa,data).subscribe(response => {
      console.log(response);
      if(response['message'] == 'Success'){
          Swal.close();
        if(response['surveyToken']){
          Swal.fire({
            icon: 'info',
            html: `<span class="modal2em">
                    ${this.translate.instant('PERFILES.USUARIO.TOKENMODAL_1')}<br><br>
                    <span id="survTok" class="survTok">${response['surveyToken']}</span><br><br>
                    ${this.translate.instant('PERFILES.USUARIO.TOKENMODAL_2')}</span>`,
            showCancelButton: true,
reverseButtons: true,
            confirmButtonText: this.translate.instant('PERFILES.USUARIO.TOKEN_SI'),
            cancelButtonText: this.translate.instant('PERFILES.USUARIO.TOKEN_NO'),
          }).then((result) => {
            if (result.value) {
              //COPIA EL SURVEY TOKEN
              const selBox = document.createElement('textarea');
              selBox.style.position = 'fixed';
              selBox.style.left = '0';
              selBox.style.top = '0';
              selBox.style.opacity = '0';
              selBox.value = response['surveyToken'];
              document.body.appendChild(selBox);
              selBox.focus();
              selBox.select();
              document.execCommand('copy');
              document.body.removeChild(selBox);

              Swal.fire({
                icon: 'success',
                title: this.translate.instant('PERFILES.USUARIO.TOKEN_COPIADO'),
                confirmButtonText: 'OK',
              }).then((result) => {
                // if (this.selectSector == 40 && this.instituto==1 || this.selectSector == 40 && this.instituto==2 || this.selectSector == 41 && this.instituto==1 ||this.selectSector == 41 && this.instituto==2) {
                if (this.idsProductosSendEmailRT.includes(this.selectSector) && this.idsInstitutosSendEmailRT.includes(this.instituto)) {
                  this.modalEnvioCorreoRT(response);
                }else{
                  this.finProcesoAgregarProducto();
                }
              });
            } else {
              if (this.idsProductosSendEmailRT.includes(this.selectSector) && this.idsInstitutosSendEmailRT.includes(this.instituto)) {
                this.modalEnvioCorreoRT(response);
              }else{
                console.log("no es certificar 3.0");
                this.finProcesoAgregarProducto();
              }
            }
          })
        } else{
          if (this.idsProductosSendEmailRT.includes(this.selectSector) && this.idsInstitutosSendEmailRT.includes(this.instituto)) {
            this.modalEnvioCorreoRT(response);
          }else{
            console.log("no es certificar 3.0");
            this.finProcesoAgregarProducto();
          }
        }
      }else if(response['message'] == 'Success2'){
        this.temporal = false;
        this.openSuccessSnackBar(this.translate.instant('PERFILES.USUARIO.PRODUCT_REGISTERPREVIOUS'),this.translate.instant('ALERTS.OK'));
        //this.openSuccessSnackBar('Product previously registered.','OK');
      }else if(response['message'] == '700'){
        this.temporal = false;
        this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.CERTIFICAR_EXISTENTE'),this.translate.instant('ALERTS.OK'));
        //this.openSuccessSnackBar('Product previously registered.','OK');
      }else if(response['message'] == '703'){
        this.temporal = false;
        this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.CERTIFICAR_NO_TERMINADO'),this.translate.instant('ALERTS.OK'));
        //this.openSuccessSnackBar('Product previously registered.','OK');
      }else if(response['message'] == '701'){
        this.temporal = false;
        this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.CERTIFICAR_NO_EXISTENTE'),this.translate.instant('ALERTS.OK'));
        //this.openSuccessSnackBar('Product previously registered.','OK');
      }else if(response['message'] == 'saveProducto3_12'){
        this.temporal = false;
        this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.PULSOS-COMPLETOS'),this.translate.instant('ALERTS.OK'));
        //this.openSuccessSnackBar('Product previously registered.','OK');
      }else if(response['message'] == '722'){
        this.temporal = false;
        this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.SIN_USUARIO'),this.translate.instant('ALERTS.OK'));
        //this.openSuccessSnackBar('Product previously registered.','OK');
      }else if(response['message'] == 'saveProducto3_1'){
        this.temporal = false;
        this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.PRODUCT_EXIST'),this.translate.instant('ALERTS.OK'));
        // this.openSuccessSnackBar('El producto con fecha 2025 ya existe','');
      }
      else{
        this.temporal = false;
        this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.PRODUCT_REGISTERFAIL'),this.translate.instant('ALERTS.OK'));
        //this.openErrorSnackBar('Error registering product, please try again','OK');
      }

    }, error => {
      console.log(error);
    });

  }else{
    this.restoreData();
    this.reiniciaVariables();
    this.temporal = false;
    this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.ERROR1'),this.translate.instant('ALERTS.OK'));
  }
  //this.temporal = false;

}

async modalEnvioCorreoRT(datosRespuesta:any){
  let textSendEmail='CONSULTATABLA.SEN_EMAIL_REQ_PROD';
  let btnSi='CONSULTATABLA.REQ.BTNSI';
  let btnNo='CONSULTATABLA.REQ.BTNNO';

  this.translate.get(textSendEmail).subscribe((res: string) => { textSendEmail = res; });
  this.translate.get(btnSi).subscribe((res: string) => { btnSi = res; });
  this.translate.get(btnNo).subscribe((res: string) => { btnNo = res; });
  const fruit:any = await Swal.fire({
    title: textSendEmail,
    text: this.translate.instant('CONSULTATABLA.EMAIL_REQ_INTRO'),
    input: 'select',
    showCancelButton: true,
    reverseButtons: true,
    confirmButtonText: btnSi,
    cancelButtonText: btnNo,
    inputOptions: this.idiomasRTSelect,
    inputPlaceholder: this.translate.instant('CONSULTATABLA.EMAIL_REQ_PLACE'),

    inputValidator: (value) => {
      console.log("value",value);
      return new Promise((resolve) => {
        console.log("resolve",resolve);

        if (value != '') {
      this.finProcesoAgregarProducto(true, datosRespuesta,value);
          resolve('');
        } else {
          let erro=this.translate.instant('CONSULTATABLA.WARN_SEN_EMAIL_REQ_PROD')
          resolve(erro);
        }
      })
    }
  });
  if (!fruit.value) {
this.finProcesoAgregarProducto(false,datosRespuesta,null);
}
}

getIdiomasTemplateEmailRt(instituto){
  this.encuestaService.getIdiomasTemplateEmailRT(instituto,1).subscribe((response:any) => {
console.log("response",response);
let idiomasRT:any={};
    response.correos_CGO.forEach(idioma => {
      if (idiomasRT[idioma.lang]==undefined) {
        idiomasRT[idioma.lang]=this.translate.instant('SELECTOR.'+idioma.lang);
      }
    });
console.log('Idioma arreglo', idiomasRT);
this.idiomasRTSelect=idiomasRT;

  }, error => {
    console.log(error);
  });
}

modalEnvioCorreoRTV2(datosRespuesta:any){
  Swal.fire({
    title: this.translate.instant('CONSULTATABLA.SEN_EMAIL_REQ'),
    showCancelButton: true,
reverseButtons: true,
    confirmButtonText: this.translate.instant('CONSULTATABLA.REQ.BTNSI'),
    cancelButtonText: this.translate.instant('CONSULTATABLA.REQ.BTNNO'),
  }).then((result) => {
    if (result.value) {
      this.finProcesoAgregarProducto(true, datosRespuesta);
    } else {
      this.finProcesoAgregarProducto();
    }
  })
}

finProcesoAgregarProducto(viaEnvioCorreo?:boolean, datosRespuesta?:any,idioma?:any){
  console.log("datosRespuesta",datosRespuesta);

  this.temporal = false;
  this.restoreData();
  this.reiniciaVariables();
  this.getProductsByCompany();
  if(!viaEnvioCorreo){
    this.openSuccessSnackBar(this.translate.instant('PERFILES.USUARIO.PRODUCT_REGISTEROK'),this.translate.instant('ALERTS.OK'));
    this.saveJsonProductVirtualSMS(this.idEmpresa, datosRespuesta.productoId);
  } else{
    this.modalSendEmail();
    this.envioCorreoRequetimientosTecnicos(this.idEmpresa, datosRespuesta.productoId,idioma);
    this.saveJsonProductVirtualSMS(this.idEmpresa, datosRespuesta.productoId);
  }
}

envioCorreoRequetimientosTecnicos(empresaID, productoID,idioma){
  console.log(empresaID);
  console.log(productoID);
  console.log("es certificar 3.0");
let datos={lang:idioma}
  this.odsService.sendEmailReqTecnicos(empresaID,productoID,datos).subscribe((response:any) => {
    console.log(response);
    if (response.message=='IT Manager Not Found') {
      Swal.fire({
        title: this.translate.instant('MODALES.ERRORES.IT Manager Not Found'),
        icon: "error",

      });
      Swal.close();

    }else{
      Swal.close();
      // this.restoreData();
      // this.reiniciaVariables();
      // this.temporal = false;
      this.openSuccessSnackBar(this.translate.instant('PERFILES.USUARIO.PRODUCT_REGISTEROK'),this.translate.instant('ALERTS.OK'));
      // this.openSuccessSnackBar(this.translate.instant('PERFILES.USUARIO.PRODUCT_REGISTEROK'),this.translate.instant('ALERTS.OK'));
      // this.getProductsByCompany();
    }
  }, error => {
    console.log(error);
  });

}

saveJsonProductVirtualSMS(empresaID, productoID){
  let datos={
    productoId:productoID
  }
  this.odsService.saveJsonProductVirtualSMS(empresaID,datos).subscribe((response:any) => {
    console.log(response);
  }, error => {
    console.log(error);
  });

}

modalSendEmail(){
  let textSendEmail='CONSULTATABLA.SEN_EMAIL_MODAL';
  this.translate.get(textSendEmail).subscribe((res: string) => { textSendEmail = res; });
  // this.translate.get('CERTIFICAR.FORALL.CARGANDO_PRACTICA').subscribe((res: string) => { mensaje = res; });
  console.log(this.urlAssetsEmail+'platform/img/tenor.gif');

  Swal.fire({
    imageUrl:this.urlAssetsEmail+'platform/img/tenor.gif',
    title: textSendEmail,
    allowOutsideClick: false,
    imageWidth: 100,
    imageHeight: 90,
    showConfirmButton:false

  });
}

contFecha:any;
validacionanio(data:any){
  this.contFecha=0;
  console.log(data);
  data.fechaProducto;
  console.log("Id producto "+data.productoId);
  console.log("fecha producto "+data.productoId);
  switch(data.productoId){
    case 2:
    console.log("Entro case medir normal");
    this.productosContratadosInter.productosMedir.forEach(producto => {
      if(producto.fechaMedir==data.fechaProducto){
        this.contFecha++
      }

    });
    case 11: case 12: case 13: case 14: case 15: case 16:
    console.log("Entro case 11");
    this.productosContratadosInter.productosMedir2.forEach(producto => {
      switch(producto.tipo){
        case 1:
        console.log(producto);
        if(producto.fechaProducto==data.fechaProducto){
          this.contFecha++
        }
        break;

      }
    });
    break;
    case 8:
    this.productosContratadosInter.productosCultureAudit.forEach(producto => {
      if(producto.fechaCulture==data.fechaProducto && !producto.tipo){
        this.contFecha++
      }
      console.log(producto);
    });
    break;
    case 9:
    console.log("Entro culture audit");
    this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
      if(producto.fechaCulture==data.fechaProducto && !producto.tipo){
        this.contFecha++
      }
      console.log(producto);
    });

    break;
    case 28:
    this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
      if(producto.fechaCulture == data.fechaProducto && producto.tipo == 2){
        this.contFecha++
      }
      console.log(producto);
    });

    break;
    case 29:
    this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
      if(producto.fechaCulture==data.fechaProducto && producto.tipo == 3){
        this.contFecha++
      }
      console.log(producto);
    });
    break;
    case 74:
    this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
      if(producto.fechaCulture==data.fechaProducto && producto.tipo == 29){
        this.contFecha++
      }
      console.log(producto);
    });
    break;
    case 30:
    this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
      if(producto.fechaCulture==data.fechaProducto && producto.tipo == 4){
        this.contFecha++
      }
      console.log(producto);
    });
    break;
    case 31:
    this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
      if(producto.fechaCulture==data.fechaProducto && producto.tipo == 5){
        this.contFecha++
      }
      console.log(producto);
    });
    break;
    case 32:
    this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
      if(producto.fechaCulture==data.fechaProducto && producto.tipo == 6){
        this.contFecha++
      }
      console.log(producto);
    });
    break;
    case 33:
    this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
      if(producto.fechaCulture==data.fechaProducto && producto.tipo == 7){
        this.contFecha++
      }
      console.log(producto);
    });
    break;
    case 37:
    this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
      if(producto.fechaCulture==data.fechaProducto && producto.tipo == 8){
        this.contFecha++
      }
      console.log(producto);
    });
    break;
    case 38:
    console.log(this.listaAction);
    this.listaAction.forEach(producto => {
      if(producto.tipo == 9){
        console.log("Hay coindicencia");
        this.contFecha++
      }
    });
    /*this.odsService.getProductosEmpresa(this.idEmpresa).subscribe((respuesta:backInter.infoProductos) => {
    this.productosContratadosInterTmp = respuesta;
    console.log(this.productosContratadosInterTmp);
    this.productosContratadosInterTmp.productosCultureAuditV2.forEach(producto => {
    if(producto.tipo == 9){
    console.log("Hay coindicencia");
    this.contFecha++
  }
});

}, error => {
console.log("error", error);
})*/

break;
case 44:
this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
  if(producto.fechaCulture==data.fechaProducto && producto.tipo == 10){
    this.contFecha++
  }
  console.log(producto);
});
break;
case 45:
this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
  if(producto.fechaCulture==data.fechaProducto && producto.tipo == 11){
    this.contFecha++
  }
  console.log(producto);
});
break;
case 46:
this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
  if(producto.fechaCulture==data.fechaProducto && producto.tipo == 12){
    this.contFecha++
  }
  console.log(producto);
});
break;
case 48:
this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
  if(producto.fechaCulture==data.fechaProducto && producto.tipo == 14){
    this.contFecha++
  }
  console.log(producto);
});
break;
case 64:
this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
  if(producto.fechaCulture==data.fechaProducto && producto.tipo == 22){
    this.contFecha++
  }
  console.log(producto);
});
break;
case 65:
this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
  if(producto.fechaCulture==data.fechaProducto && producto.tipo == 23){
    this.contFecha++
  }
  console.log(producto);
});
break;
case 66:
this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
  if(producto.fechaCulture==data.fechaProducto && producto.tipo == 24){
    this.contFecha++
  }
  console.log(producto);
});
break;
case 67:
this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
  if(producto.fechaCulture==data.fechaProducto && producto.tipo == 25){
    this.contFecha++
  }
  console.log(producto);
});
break;
case 71:
this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
  if(producto.fechaCulture==data.fechaProducto && producto.tipo == 26){
    this.contFecha++
  }
  console.log(producto);
});
break;
case 72:
this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
  if(producto.fechaCulture==data.fechaProducto && producto.tipo == 27){
    this.contFecha++
  }
  console.log(producto);
});
break;
case 73:
this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
  if(producto.fechaCulture==data.fechaProducto && producto.tipo == 28){
    this.contFecha++
  }
  console.log(producto);
});
break;
case 76:
this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
  if(producto.fechaCulture==data.fechaProducto && producto.tipo == 30){
    this.contFecha++
  }
  console.log(producto);
});
break;
case 77:
this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
  if(producto.fechaCulture==data.fechaProducto && producto.tipo == 31){
    this.contFecha++
  }
  console.log(producto);
});
break;
case 78:
this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
  if(producto.fechaCulture==data.fechaProducto && producto.tipo == 32){
    this.contFecha++
  }
  console.log(producto);
});
break;
case 50:
this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
  if(producto.fechaCulture==data.fechaProducto && producto.tipo == 16){
    this.contFecha++
  }
  console.log(producto);
});
break;
case 51:
this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
  if(producto.fechaCulture==data.fechaProducto && producto.tipo == 17){
    this.contFecha++
  }
  console.log(producto);
});
case 55:
this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
  if(producto.fechaCulture==data.fechaProducto && producto.tipo == 18){
    this.contFecha++
  }
  console.log(producto);
});
break;
/* case 12:
console.log("Entro case 12");
this.productosContratadosInter.productosMedir2.forEach(producto => {
switch(producto.tipo){
case 2: if(producto.fechaProducto==data.fechaProducto){this.contFecha++} break;

}
});
break;
case 13:
console.log("Entro case 13");
this.productosContratadosInter.productosMedir2.forEach(producto => {
switch(producto.tipo){
case 3: if(producto.fechaProducto==data.fechaProducto){this.contFecha++} break;

}
});
break;
case 14:
console.log("Entro case 14");
this.productosContratadosInter.productosMedir2.forEach(producto => {
switch(producto.tipo){
case 4: if(producto.fechaProducto==data.fechaProducto){this.contFecha++} break;

}
});
break;
case 15:
console.log("Entro case 15");
this.productosContratadosInter.productosMedir2.forEach(producto => {
switch(producto.tipo){
case 5: if(producto.fechaProducto==data.fechaProducto){this.contFecha++} break;

}
});
break;
case 16:
console.log("Entro case 16");
this.productosContratadosInter.productosMedir2.forEach(producto => {
switch(producto.tipo){
case 6: if(producto.fechaProducto==data.fechaProducto){this.contFecha++} break;

}
});
break;*/
default:
this.contFecha=0;
break;
}
console.log("Fecha "+this.contFecha);
if(this.contFecha >0){
  console.log("Na, ya esta repetido");
  return false;
}else{
  console.log("si se puede brothar");
  return true;
}
}

checkifCA(){
  if([8,9,10,28,29,30,31,32,33,37,38,44,45,46,48,49,50,51,55,59,61,62,64,65,66,67,71,72,73,74,76,77,78,80].includes(this.selectSector)){
    this.isCA = true;
  }else{
    this.isCA = false;
  }
}

openErrorSnackBar(message: string, action: string) {
  Swal.fire({
    icon: 'error',
    title: message,
    confirmButtonText: action,
    confirmButtonColor: '#e40601'
  });
}

changueSelects(data) {
  console.log(data);
}

openSuccessSnackBar(message: string, action: string) {

  Swal.fire({
    icon: 'success',
    title: message,
    confirmButtonText: action,
    confirmButtonColor: '#e40601'
  });
}

drop(event: CdkDragDrop<string[]>,arreglo:any, fecha:number, idProducto?:any) {
  //console.log(arreglo);
  moveItemInArray(arreglo, event.previousIndex, event.currentIndex);
  this.updatePosition(arreglo,fecha,idProducto);
}

updatePosition(arreglo:any[],fecha:number,idProducto?:any){

  for (let i = 0; i < arreglo.length; i++) {
    let data:any = {
      seccionId: arreglo[i]['_id'],
      orden: i+1
    }
    if(idProducto){
      data.productoId = idProducto;
    }
    else{
      data.fechaCertificar = fecha;
    }
    // console.log(data);
    this.odsService.updateStatus(this.idEmpresa,data)
    .subscribe(response => {
      //console.log(response);
    }, error => {
      console.log(error);
    });
  }

}


updateStatus(event:any, seccion:any, fecha?:number, idProducto?:any,tokenConfig?:any,nameSection?:any,exisSurvey?:any,tipoProducId?:any,indexProGene?:number,indexProductos?:number,indexSecc?:number){
   console.log('tipoProducId',tipoProducId);
  let accionText:string;
  switch (nameSection) {
    case 'NPS':
      if (event['checked']) {
        accionText='activoSeccionNps';
      }else{
        accionText='desActivoSeccionNps';
      }
      break;
    case 'Reactivos':
    if (event['checked']) {
      accionText='activoSeccionReactivos';
    }else{
      accionText='desActivoSeccionReactivos';
    }
      break;
    case 'Control':
    if (event['checked']) {
      accionText='activoSeccionControl';
    }else{
      accionText='desActivoSeccionControl';
    }
      break;
    case 'Demograficos':
    if (event['checked']) {
      accionText='activoSeccionDemograficos';
    }else{
      accionText='desActivoSeccionDemograficos';
    }
      break;
    case 'Abiertas':
    if (event['checked']) {
      accionText='activoSeccionAbiertas';
    }else{
      accionText='desActivoSeccionAbiertas';
    }
      break;
    case 'Forall':
    if (event['checked']) {
      accionText='activoSeccionForall';
    }else{
      accionText='desActivoSeccionForall';
    }
      break;
    case 'Adicionales':
    if (event['checked']) {
      accionText='activoSeccionAdicionales';
    }else{
      accionText='desActivoSeccionAdicionales';
    }
      break;

    default:
      break;
  }
  console.log('accionText',accionText);

  let data:any = {
    seccionId: seccion,
    estatus: event['checked'],
    accionText:accionText,
    userAdministrator:localStorage.getItem('user_padre'),
  };
  if(idProducto){
    data.productoId = idProducto;
  }
  else{
    data.fechaCertificar = fecha;
  }
  // console.log(data);
  if (exisSurvey) {
console.log('Ya cuenta con encuesta creada');
let textConfirma='CONSULTATABLA.CONFIR_CAMBIOS_SECCION';
this.translate.get(textConfirma).subscribe((res: string) => { textConfirma = res; });
let textSi='CONSULTATABLA.REQ.BTNSI';
this.translate.get(textSi).subscribe((res: string) => { textSi = res; });
let textNo='CONSULTATABLA.REQ.BTNNO';
this.translate.get(textNo).subscribe((res: string) => { textNo = res; });
Swal.fire({
  title: textConfirma,
  showCancelButton: true,
reverseButtons: true,
  confirmButtonText: textSi,
  cancelButtonText: textNo,
}).then((result) => {
  if (result.value) {
let datos={
  modalFlag:true,
}
this.modalGuardado(1);
    this.odsService.updateFlagCambios(this.idEmpresa,idProducto,datos).subscribe(response => {
      console.log(response);
      if (response['success']==true) {
        this.odsService.updateStatus(this.idEmpresa,data).subscribe(response => {
          console.log(response);

          Swal.close();
        }, error => {
          console.log(error);
        });

      }else{
        console.log('no se ejecuto el cambio de la variable');
      }


    }, error => {
      console.log(error);
    });




  } else {
console.log('indexProGene',indexProGene);
console.log('indexProductos',indexProductos);
console.log('indexSecc',indexSecc);
if (tipoProducId==40 || tipoProducId==20 || tipoProducId==1) {
    console.log('Certificar');
this.listaProdsCertificar[indexProGene].lista[indexProductos].secciones[indexSecc].estatus=!event['checked'];
}else if (tipoProducId==11|| tipoProducId==41 || tipoProducId==16) {
  console.log('medir');
  this.listaProdsMedir[indexProGene].lista[indexProductos].secciones[indexSecc].estatus=!event['checked'];

}else if (tipoProducId==42) {
  console.log('Pulsecheck');
  this.listaProdsPulse[indexProGene].lista[indexProductos].secciones[indexSecc].estatus=!event['checked'];
}else if (tipoProducId==43) {
  console.log('Focus area');
  this.aniosFocusAgregados[indexProGene].datos[indexProductos].secciones[indexSecc].estatus=!event['checked'];
}
  }
})
  }else{
     console.log('data',data);

      this.odsService.updateStatus(this.idEmpresa,data).subscribe(response => {
      console.log(response);

    }, error => {
      console.log(error);
    });

  }
}


pulseCheckAños(){
  this.aniosPulsecheck=[];
  let fechaActual:number;
  let fechaPulse:any[]=[];
  this.productosContratadosInterPulse.productosPulseCheck.sort( (a,b) => {
    if(a.fechaPulseCheck > b.fechaPulseCheck){
      return 1;
    } else{
      return -1;
    }
  });
  this.productosContratadosInterPulse.productosPulseCheck.forEach((element,i) => {
    if(fechaActual){
      if(element.fechaPulseCheck == fechaActual){
        fechaPulse.push(element);
      }
      else {
        this.aniosPulsecheck.push({fecha: fechaActual, datos: fechaPulse });
        fechaPulse=[];
        fechaActual=element.fechaPulseCheck;
        fechaPulse.push(element);
      }
    }
    else{
      fechaActual=element.fechaPulseCheck;
      fechaPulse.push(element);
    }
    fechaPulse.sort( (a,b) => {
      if(a.numero > b.numero){ return 1; } else{ return -1; }
    });
    if(this.productosContratadosInterPulse.productosPulseCheck.length ==(i+1)){
      this.aniosPulsecheck.push({fecha: element.fechaPulseCheck, datos: fechaPulse });
    }
  });
  console.log(this.aniosPulsecheck);
}

focusAreaAñosMenus(){
  this.aniosFocusAgregados=[];
    let fechaActual:number;
    let fechaPulse:any[]=[];
    let anioNoSeleccionados:any[]=[];


this.listaProdsFocus[1].lista.forEach(anioAgregado => {
  // console.log('anioAgregado',anioAgregado);
  if (anioAgregado.idProducto==43) {
  anioNoSeleccionados.push(anioAgregado);
  }
});

    anioNoSeleccionados.sort( (a,b) => {
      if(a.fechaCertificar > b.fechaCertificar){
        return 1;
      } else{
        return -1;
      }
    });
    console.log(anioNoSeleccionados);
    anioNoSeleccionados.forEach((element,i) => {
      // console.log('element',element);

      // console.log(element.completoCertificar);
      if(fechaActual){
        if(element.fechaCertificar == fechaActual){
          // fechaPulse.push(element);
          fechaPulse.push(element);
        }
        else {
          this.aniosFocusAgregados.push({fecha: fechaActual, datos: fechaPulse });
          fechaPulse=[];
          fechaActual=element.fechaCertificar;
          // fechaPulse.push(element);
          fechaPulse.push(element);
        }
      }
      else{
        fechaActual=element.fechaCertificar;
        // fechaPulse.push(element);
        fechaPulse.push(element);
      }
      fechaPulse.sort( (a,b) => {
        if(a.numPulse > b.numPulse){ return 1; } else{ return -1; }
      });
      if(anioNoSeleccionados.length ==(i+1)){
        this.aniosFocusAgregados.push({fecha: element.fechaCertificar, datos: fechaPulse});
      }
    });
  console.log('this.aniosFocusAgregados',this.aniosFocusAgregados);
}


navigateToFocus(ruta,empresaId,productoID,fecha,version){
  console.log(version);

  localStorage.setItem('empresaID', empresaId);
  localStorage.setItem('productoID', productoID);
  console.log(localStorage.getItem('productoID'));
  localStorage.setItem('fechaProducto', fecha);
  localStorage.setItem('version', version);
  this.router.navigate([ruta]);
  console.log(ruta);
}

openDialog(fecha, idproducto, plantilla, tipoproducto,producId?,idSurveyMenos?,idSurveyMas?): void {
  console.log("Codigo del proyecto "+this.codigoDeProyecto);
  if (tipoproducto==5) {

    console.log("idSurveyMenos"+idSurveyMenos);
    console.log("idSurveyMas"+idSurveyMas);
    if (idSurveyMenos==null&&idSurveyMas==null) {
      Swal.fire({
        title: this.translate.instant('CONSULTATABLA.WARNI_NOT_SURV_NOM35'),
        icon: 'warning',
        confirmButtonText: this.translate.instant('ALERTS.OK'),
        confirmButtonColor: '#e40601'
      })

    }else{
      let dataModal: any;
      const dialogRef = this.dialog.open(DescargaEncuestaComponent, {
        width: '500px',
        data: {
          fecha:fecha,
          idProducto:idproducto,
          tipoProducto:tipoproducto,
          plantilla:plantilla,
          idEmpresa:this.idEmpresa,
          nombreEmpresa:this.nombreEmpresa,
          codigoDeProyecto:this.codigoDeProyecto,
          productoId:producId,
          instituto:localStorage.getItem('instituto_correos'),
        }
      });
      dialogRef.afterClosed().subscribe(result => {
      });

    }
  }else{
    let dataModal: any;
    const dialogRef = this.dialog.open(DescargaEncuestaComponent, {
      width: '500px',
      data: {
        fecha:fecha,
        idProducto:idproducto,
        tipoProducto:tipoproducto,
        plantilla:plantilla,
        idEmpresa:this.idEmpresa,
        nombreEmpresa:this.nombreEmpresa,
        codigoDeProyecto:this.codigoDeProyecto,
        productoId:producId,
        instituto:localStorage.getItem('instituto_correos'),
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

}

modalGuardado(tipo:number){
  let mensaje: string;
  switch (tipo) {
    case 1:
    this.translateSrv.get('CONSULTATABLA.MODAL_CAMBIOS_SECCION').subscribe((res: string) => { mensaje = res; });
      break;
    case 2:
    this.translateSrv.get('PERFILES.USUARIO.GUARDANDOPRODUCTO').subscribe((res: string) => { mensaje = res; });
      break;
    case 3:
    this.translateSrv.get('CONSULTATABLA.PROC_DELE_PROD').subscribe((res: string) => { mensaje = res; });
      break;
    case 4:
    // mensaje="Se está creando la infraEstructura, porfavor espere"
    this.translateSrv.get('CONSULTATABLA.MODAL_CREAT_INFRA').subscribe((res: string) => { mensaje = res; });
      break;
    default:
      break;
  }
  Swal.fire({
    title: mensaje,
    allowOutsideClick: false,
    showConfirmButton: false,
    imageUrl: localStorage.getItem('urlGifBroker'),
    imageWidth: 100,
    imageHeight: 60,
  });
}

obtieneCorreoJefe(result){
  console.log('result',result);
  this.proyectManagerEmail=result.email;
}

getRankigRangeColaboradores(){
  this.odsService.getRankigRangeColab(this.instituto,this.translateSrv.currentLang).subscribe(response => {
    console.log('nuevo servicio response',response);
    // this.rankingItem = response['result'];

    Swal.close();
  }, error => {
    console.log(error);
  });
}


getCatalogoRangoColaboradoresV1(country){
  this.odsService.getCatalogoRangoColaboradores(this.instituto,this.translate.currentLang,country).subscribe((respuesta:any) => {
    console.log("getCatalogoRangoColaboradores:",respuesta);
    this.rankingItem = respuesta.result;
  });
}

verInfoProducGoFlow(infoProducto){
  console.log("infoProducto",infoProducto);
  const dialogRef = this.dialog.open(ConfigResultComponent, {
    width: '60%',
    height: '70%',
    data: {
      empresaId: this.idEmpresa,
      InfoGral: infoProducto,
      tipo:'goFlow',
      nombreEmpresa:this.nombreEmpresa,
      instituto:this.instituto,
    }
  });
  dialogRef.afterClosed().subscribe(result => {
  });

}

}
